<template>
<!--   :class="{'is-reverse': isReverse && !cPoorNetworkEnvironmentStatus}" -->
  <div class="mick-wrap">
    <div class="is-reverse-tip" v-if="isReverse" style="max-width: 1000px">
      <van-icon name="warning-o" size="18" color="#FF9275" />
      <p class="text">反向下单模式开启中， 请谨慎下单</p>
    </div>
    <div class="mick-box"  :class="{'is-reverse': isReverse, 'error-network': cPoorNetworkEnvironmentStatus}">
      <van-cell center title="反向下单模式">
        <template #right-icon>
          <van-switch v-model="isReverse" size="18" active-color="#1c0955" inactive-color="#dcdee0" @change="changeReverseOrder" />
        </template>
      </van-cell>
    </div>
    <div class="form-box">
      <custom-select v-model="form.way" :columns="wayCurrencyColumns" label="下单方式" type="number" clearable
                     input-align="left" placeholder="请选择" readonly @change="handWayChange">
      </custom-select>
      <custom-select v-model="form.account_group" :columns="accountCurrencyColumns"
                     :label="form.way === 1 ? '账户组' : '账户'" type="number" clearable input-align="left"
                     placeholder="请选择"
                     readonly @change="handGroupChange">
      </custom-select>
    </div>
    <!-- 二层 -->
    <div class="second-box no-bor">
      <van-cell-group inset>
        <van-field v-model="form.name_code" name="名称代码" label="名称代码" placeholder="请输入内容"
                   right-icon="search"
                   @input="handSymbolChange" />
      </van-cell-group>

      <van-overlay :show="symbolListShow" class="overlay-top"
                   :lock-scroll="false"
                   :class="{showNetworkTips: cPoorNetworkEnvironmentStatus, 'is-reverse': isReverse}"
                   style="max-width: 1000px;transform: translateX(-50%);left:50%">
        <div class="symbolList-box" v-if="symbolList && symbolList.length > 0">
          <van-cell-group>
            <van-cell :title="item.origin_symbol" :value="item.contract_name" v-for="item in symbolList"
                      :key="item.symbol" @click="handSymbolClick(item)" >
              <template #extra>
                <span class="is_main" v-if="item.is_main == 1">主力</span>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
        <!-- 无搜索结果 -->
        <div class="noData" v-else>
          <img class="icon" src="@/assets/images/h5Page/prompt.png" />
          <span class="text">暂无搜索结果</span>
        </div>
      </van-overlay>
      <div v-if="goodsShow && symbolGoods.name" class="symbol-div">
        <!-- <van-divider :style="{ color: '#eeeeee', borderColor: '#eeeeee',margin:'0px' }" /> -->
        <div class="symbol-detail">
          <span>{{ symbolGoods.name }}</span>
          <span style="font-size:12px;color:#888888;padding-left:8px;">{{ form.name_code }}</span>

          <div class="tick-time" v-if="symbolGoods.date_time_stamp">{{tickTimeText(symbolGoods.date_time_stamp)}}</div>
        </div>

        <div
          :class="parseFloat(symbolGoods.change_value) < 0 ? 'lowDetail': parseFloat(symbolGoods.last_price) === 0 && parseFloat(symbolGoods.change_value) === 0 && parseFloat(symbolGoods.change_rate) === 0 ? 'pinDetail' : 'upDetail'"
          class="symbol-detail">
          <div style="text-align: left;margin-right:16px;margin-top:0.16rem;" v-if="symbolGoods.level <= 0 && symbolGoods.contract_type == 84">
            <div class="ovely-text"
                 style="width:16px;height:16px;color:#fff;border-radius:2px;font-size:12px;background:linear-gradient(148deg,#d6b996 7%, #ab8e6e 92%);line-height:18px;text-align:center;">
              延
            </div>
          </div>
          <div style="flex:1;text-align: left;"
               :class="parseFloat(symbolGoods.change_value) < 0 ? 'downColor' : parseFloat(symbolGoods.last_price) === 0 ? 'pinColor' : 'upColor'">
            {{
              symbolGoods.last_price ? parseFloat(symbolGoods.last_price).toFixed(symbolGoods.digits) : "--"
            }}
          </div>
          <div style="flex:1;text-align: left;"
               :class="parseFloat(symbolGoods.change_value) < 0 ? 'downColor' : parseFloat(symbolGoods.change_value) === 0 ? 'pinColor' : 'upColor'">
            {{
              symbolGoods.change_value ? parseFloat(symbolGoods.change_value).toFixed(symbolGoods.digits) : symbolGoods.change_value === 0 ? parseFloat(symbolGoods.change_value).toFixed(symbolGoods.digits) : parseFloat(0).toFixed(symbolGoods.digits)
            }}
          </div>
          <div style="flex:1;text-align: left;"
               :class="parseFloat(symbolGoods.change_value) < 0 ? 'downColor' : parseFloat(symbolGoods.change_rate) === 0 ? 'pinColor' : 'upColor'">
            {{
              symbolGoods.change_rate ? parseFloat(symbolGoods.change_rate).toFixed(2) + "%" : symbolGoods.change_rate === 0 ? parseFloat(symbolGoods.change_value).toFixed(2) + "%" : parseFloat(0).toFixed(symbolGoods.digits) + "%"
            }}
          </div>
        </div>

      </div>


    </div>
    <!-- 三层 -->
    <div class="second-box no-bor">
      <van-cell title="类型" class="cell-type" :value="form.type" @click="handTypeChange">
        <template #right-icon>
          <img :src="selectImg" alt="">
        </template>
      </van-cell>

      <van-action-sheet v-model="actionsShow" style="max-width: 1000px;transform: translateX(-50%);left:50%">
        <div class="cell-box" v-for="item in actionsType" :key="item.value" @click="handATypeChange(item)">
					<span
            :style="{'font-weight':resultIsShow == item.value ? 600 : 100,'padding-left':resultIsShow == item.value ? '60px':'0px'}">{{
              item.name
            }}</span>
          <img :src="actionsImg"
               style="width: 17px;height:17px;float: right;margin-right: 43px;margin-top: 18px;"
               v-if="resultIsShow == item.value" />
        </div>
        <div class="cell-box1" v-if="actionsType.length > 0" @click="actionsShow = false">
          取消
        </div>
      </van-action-sheet>
      <div style="display:flex;">
        <van-field v-model="form.order_price" name="价格" label="价格" placeholder="请输入价格"
                   @input="handNumberChange"
                   v-if="priceShow" />
        <div class="delPngBox" v-if="priceShow">
          <img :src="delPrPng" class="delPng" @click="handPriceDel" />
        </div>
        <div class="delPngBox" v-if="priceShow">
          <img :src="adPrPng" class="adPng" @click="handPriceAdd" />
        </div>
      </div>

      <div class="tag-box" v-if="tagShow">
        <div class="tag" v-for="item in tagList" :key="item.id" :class="tagActive === item.id?'tagActive':'tag'"
             @click="handTag(item)">
          {{ item.name }}
        </div>
      </div>
      <div class="form-end-box">
        <!-- :style="{'flex':form.number === 2 ? 2 : 1}" -->
        <div class="select-box" :style="{'flex': 1}">
          <!-- <custom-select v-model="form.number" :columns="numCurrencyColumns" label="数量" type="number"
						clearable input-align="left" placeholder="请选择" readonly @change="handCurryChange">
					</custom-select> -->


          <van-cell title="数量" class="cell-type" :value="numberName" @click="handCurryChange"
                    style="color:#323233;">
            <template #right-icon>
              <img :src="selectImg" alt="">
            </template>
          </van-cell>

          <van-action-sheet v-model="numShow" style="max-width: 1000px;transform: translateX(-50%);left:50%">
            <div class="cell-box" v-for="item in getnumCurrencyColumns" :key="item.value"
                 @click="handACurryChange(item)">
							<span
                :style="{'font-weight':resultNum == item.value ? 600 : 100,'padding-left':resultNum == item.value ? '70px':'0px'}">{{
                  item.text
                }}</span>
              <img :src="actionsImg"
                   style="width: 17px;height:17px;float: right;margin-right: 43px;margin-top: 18px;"
                   v-if="resultNum == item.value" />
            </div>
          </van-action-sheet>


        </div>
        <div class="select-box input-line" v-if="form.number == 1 || form.number == 3">
          <van-field v-model="form.numberText" placeholder="请输入" @input="handNumberChange" type="digit" />
          <div class="delPngBox">
            <img :src="delPng" class="delPng" @click="handNumberDel" />
          </div>
          <div class="delPngBox">
            <img :src="adPng" class="adPng" @click="handNumberAdd" />
          </div>
        </div>
        <div class="select-box input-line" v-if="form.number == 2">
          <van-field v-model="form.numberText" placeholder="请输入" @input="handNumberChange" type="number"
                     maxlength="5" />
          <div class="delPngBox">
            <img :src="delPng" class="delPng" @click="handNumberDel" />
          </div>
          <div class="delPngBox">
            <img :src="adPng" class="adPng" @click="handNumberAdd" />
          </div>
        </div>
      </div>
      <!-- || form.number === 3) || form.number === 3) || form.number === 3)-->
      <div class="hkList" v-if="symbolGoods.name && form.number === 1 && form.numberText">
        <div class="van-field__label" v-if="symbolGoods.name && form.number === 1 ">
          {{ symbolGoods.contract_type === 84 ? "金额" : "保证金" }}
        </div>
        <div style="margin-right: 0.32rem;" v-show="symbolGoods.name && form.number === 1 ">
          {{
            (form.typeValue === 50 || form.typeValue === 72) && symbolGoods.contract_type === 84 ? amount : symbolGoods.contract_type === 70 ? amount : amount + "(参考金额)"
          }}
        </div>
        <div v-if="symbolGoods.exchange_code === 'HKEX' && symbolGoods.contract_type === 70 && (this.form.typeValue == 66 && !hasAuction.includes(symbolGoods.commodity_no) || this.form.typeValue != 66)" class="hk-div">
          <!-- <input type="checkbox" v-model="HKT1" /> -->
          <van-checkbox v-model="HKT1" shape="square"></van-checkbox>
          <span>HK T+1</span>
        </div>
      </div>

      <div class="hkList"
           v-if="symbolGoods.name && form.number === 2 && symbolGoods.exchange_code === 'HKEX' && symbolGoods.contract_type === 70 && form.numberText">
        <div v-if="symbolGoods.exchange_code === 'HKEX' && symbolGoods.contract_type === 70 && (this.form.typeValue == 66 && !hasAuction.includes(symbolGoods.commodity_no) || this.form.typeValue != 66)" class="hk-div">
          <!-- <input type="checkbox" v-model="HKT1" /> -->
          <van-checkbox v-model="HKT1" shape="square"></van-checkbox>
          <span>HK T+1</span>
        </div>
      </div>


    </div>

    <!-- 四层 -->


    <!-- 按钮组 -->
    <div class="bottom-btn">
      <div class="btn-box" :class="{def: !priceShow || !symbolGoods.name || !form.order_price}">
        <van-button block class="buy-btn" @click="newSubmitOrder(1)" :disabled="isOver" style="font-size:14px;">
          <div style="color:#fff;border-bottom: 1px solid;padding-bottom: 5px;margin-bottom: 5px;"
               v-show="priceShow && symbolGoods.name && form.order_price">{{ form.order_price }}
          </div>
          <div style="font-size:14px;">买入</div>
        </van-button>
      </div>
      <div class="btn-box" :class="{def: !priceShow || !symbolGoods.name || !form.order_price}">
        <!-- :disabled="isOver || havePosition" -->
        <van-button block class="sell-btn" @click="newSubmitOrder(2)" style="font-size:14px;"
                    :disabled="isOver || havePosition">
          <div style="color:#fff;border-bottom: 1px solid;padding-bottom: 5px;margin-bottom: 5px;"
               v-show="priceShow && symbolGoods.name && form.order_price">{{
              !isFocse && tagActive === 0 && symbolGoods.last_price ?
                parseFloat(symbolGoods.last_price).toFixed(this.symbolGoods.digits) :
                !isFocse && tagActive === 1 && symbolGoods.ask_price ? parseFloat(symbolGoods.ask_price).toFixed(this.symbolGoods.digits) :
                  !isFocse && tagActive === 2 && symbolGoods.bid_price ? parseFloat(symbolGoods.bid_price).toFixed(this.symbolGoods.digits) :
                    form.order_price
            }}
          </div>
          <div style="font-size:14px;">卖出</div>
        </van-button>
      </div>
    </div>

    <div class="account-details-box">
      <account-details @changeActiveTab="changeActiveTab" :query-mode="(form.way-1)" :group-obj="groupObj" ref="account-details"></account-details>
    </div>

    <van-dialog v-model="orderShow" title="下单确认" :show-confirm-button="false" width="90vw"
                style="max-width: 900px;">
      <div class="cell-box-dia">
        <div class="cell-lable">账户</div>
        <div class="cell-value" v-if="this.form.way === 2">
          <span>{{ account_no }}({{ name }})</span>
        </div>
        <div class="cell-value" v-if="this.form.way === 1">
          <span @click="showPopover = !showPopover">{{ account_no }}</span>
          <img :src="selectImg" alt="" @click="showPopover = !showPopover">
          <div v-if="showPopover" class="select-option">
            <div class="select-option-item" v-for="item in actionsGroup">
              {{ item.text }}
              ({{ item.id }})
            </div>
          </div>
        </div>

      </div>
      <div class="cell-box-dia" @click="handClosePop">
        <div class="cell-lable">订单类型</div>
        <div class="cell-value label-name">
          {{ form.type }}
        </div>
      </div>


      <div class="cell-box-dia" @click="handClosePop">
        <div class="cell-lable">名称代码</div>
        <div class="cell-value" style="flex: 2;">
          <div class="label-name">{{ symbolGoods.name }}</div>
          <div class="span-name">{{ form.name_code }}</div>
        </div>
      </div>
      <div class="cell-box-dia" @click="handClosePop">
        <div class="cell-lable">方向</div>
        <div class="cell-value label-name">
          {{ isBuy ? "买入" : "卖出" }}
        </div>
      </div>
      <div class="cell-box-dia">
        <div class="cell-lable">数量</div>
        <div class="cell-value label-name" v-if="form.number === 1">
          固定
          <span>{{ form.numberText }}</span>
          <span>{{ symbolGoods.contract_type === 84 ? "股" : "手" }}</span>
        </div>
        <div class="cell-value label-name" v-if="form.number === 2">
          <span @click="showPopoverN = !showPopoverN">按资金比例</span>
          <span @click="showPopoverN = !showPopoverN">{{ form.numberText }}</span>
          <span @click="showPopoverN = !showPopoverN">%</span>
          <img :src="selectImg" alt="">
          <div class="table-option" v-if="showPopoverN">
            <div style="flex:1;">
              <div class="table-option-item">账户</div>
              <div class="table-option-item" v-for="item in tableList">
                {{ item.account_no }}
                ({{ item.account_name }})
              </div>
            </div>
            <div style="flex:1;">
              <div class="table-option-item">数量{{ symbolGoods.contract_type === 84 ? "(股)" : "(手)" }}</div>
              <div class="table-option-item" v-for="item in tableList">
                {{ item.order_qty }}
              </div>
            </div>
            <div style="flex:1;">
              <div class="table-option-item">
                {{ symbolGoods.contract_type === 84 ? "金额" : "保证金" }}
              </div>
              <div class="table-option-item" v-for="item in tableList">
                <!-- {{ (form.typeValue === 50 || form.typeValue === 72) && symbolGoods.contract_type === 84 ? (parseFloat(item.order_price) * parseFloat(item.order_qty)).toFixed(2) : symbolGoods.contract_type === 70 ? (parseFloat(amount) * parseFloat(item.order_qty)).toFixed(2) : (parseFloat(item.order_price) * parseFloat(item.order_qty)).toFixed(2) + '(参考金额)' }} -->
                {{
                  (form.typeValue === 50 || form.typeValue === 72) && symbolGoods.contract_type === 84 ? item.market_value : symbolGoods.contract_type === 70 ? item.margin_amount : item.market_value + "(参考金额)"
                }}
              </div>
            </div>
          </div>
        </div>


        <div class="cell-value label-name" v-if="form.number === 3">
          <span @click="showPopoverN = !showPopoverN">按倍数</span>
          <span @click="showPopoverN = !showPopoverN">{{ form.numberText }}</span>
          <span>{{ symbolGoods.contract_type === 84 ? "股" : "手" }}</span>
          <img :src="selectImg" alt="">
          <div class="table-option" v-if="showPopoverN">
            <div style="flex:1;">
              <div class="table-option-item">账户</div>
              <div class="table-option-item" v-for="item in tableList">
                {{ item.account_no }}
                ({{ item.account_name }})
              </div>
            </div>
            <div style="flex:1;">
              <div class="table-option-item">数量{{ symbolGoods.contract_type === 84 ? "(股)" : "(手)" }}</div>
              <div class="table-option-item" v-for="item in tableList">
                {{ item.order_qty }}
              </div>
            </div>
            <div style="flex:1;">
              <div class="table-option-item">
                {{ symbolGoods.contract_type === 84 ? "金额" : "保证金" }}
              </div>
              <div class="table-option-item" v-for="item in tableList">
                <!-- {{ (form.typeValue === 50 || form.typeValue === 72) && symbolGoods.contract_type === 84 ? (parseFloat(item.order_price) * parseFloat(item.order_qty)).toFixed(2) : symbolGoods.contract_type === 70 ? (parseFloat(amount) * parseFloat(item.order_qty)).toFixed(2) : (parseFloat(item.order_price) * parseFloat(item.order_qty)).toFixed(2) + '(参考金额)' }} -->
                {{
                  (form.typeValue === 50 || form.typeValue === 72) && symbolGoods.contract_type === 84 ? item.market_value : symbolGoods.contract_type === 70 ? item.margin_amount : item.market_value + "(参考金额)"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell-box-dia" v-if="priceShow" @click="handClosePop">
        <div class="cell-lable">委托价格</div>
        <div class="cell-value label-name">
          {{ tagActive == 1 && !isBuy ? symbolGoods.ask_price.toFixed(this.symbolGoods.digits) : tagActive == 2 && !isBuy ? symbolGoods.bid_price.toFixed(symbolGoods.digits) : form.order_price
          }}
        </div>
      </div>

      <div class="cell-box-dia" v-if="form.number === 1" @click="handClosePop">
        <div class="cell-lable">
          {{ symbolGoods.contract_type === 84 ? "金额" : "保证金" }}
        </div>
        <div class="cell-value label-name">
          {{
            (form.typeValue === 50 || form.typeValue === 72) && symbolGoods.contract_type === 84 ? amount : symbolGoods.contract_type === 70 ? amount : amount + "(参考金额)"
          }}
        </div>
      </div>

      <div class="">
        <div class="secondary-confirm-content">
          <van-checkbox v-model="create_order" shape="square">
            <template #icon="props">
              <div style="display:flex;">
                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                <div class="img-text">下次不再提醒</div>
              </div>

            </template>
          </van-checkbox>
        </div>
        <div class="notes" v-if="create_order">
          备注：关闭后，提交订单将不会收到二次确认弹窗，如需开启，可在交易设置修改
        </div>
        <!-- <van-checkbox v-model="create_order" shape="square"></van-checkbox>
				<span>下次不再提醒</span> -->
      </div>


      <div class="cell-box-dia dialog-btn dialog-btn-mk" style="" @click="handClosePop">
        <div class="cell-lable" style="padding-right: 16px;">
          <van-button plain type="primary" style="background: #fff;border: 1px solid #1C0955;color: #1C0955;"
                      @click="handClose">取消
          </van-button>
        </div>
        <div class="cell-value">
          <van-button type="primary" @click="handConfirm">确认</van-button>
        </div>
      </div>

    </van-dialog>
  </div>
</template>

<script>
import CustomSelect from "@/views/create-account/components/CustomSelect.vue";
import AccountDetails from "./accountDetails/index.vue";
import {
  Form,
  Field,
  CellGroup,
  Button,
  Overlay,
  Cell,
  Empty,
  Checkbox,
  ActionSheet,
  Dialog,
  Popover,
  Toast,
  Divider,
  Popup,
  Picker,
  Switch,
  Icon
} from "vant";
import axios from "axios";
import {
  queryBatchorder
} from "@/apis/modules/h5-page";
import {
  sendSock,
  getSock,
  closeWebSocket,
  openWebSocket
} from "@/utils/ws";
import "vant/lib/divider/style";
import { formatDate } from "@/utils/date"
import bus from "@/utils/bus";
export default {
  components: {
    CustomSelect,
    AccountDetails,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    [Cell.name]: Cell,
    [Empty.name]: Empty,
    [Checkbox.name]: Checkbox,
    [ActionSheet.name]: ActionSheet,
    [Dialog.Component.name]: Dialog.Component,
    [Popover.name]: Popover,
    [Toast.name]: Toast,
    [Divider.name]: Divider,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Switch.name]: Switch,
    [Icon.name]: Icon
  },
  data() {
    return {
      hasAuction: ["HSI", "MHI", "HHI", "MCH"], // 包含竞价单的 类型
      noPriceType: ["66", "49", "51", "71"],
      isReverse: false, // 是否是反向操作
      wayCurrencyColumns: [{
        text: "按组",
        value: 1
      },
        {
          text: "按账户",
          value: 2
        }
      ],
      accountCurrencyColumns: [],
      form: {
        way: 1,
        account_group: "",
        name_code: "",
        type: "",
        order_price: "",
        number: 1,
        numberText: "",
        typeValue: "",
        group_type: ""
      },
      tagList: [{
        id: 0,
        name: "最新价"
      }, {
        id: 1,
        name: "排队价"
      }, {
        id: 2,
        name: "对手价"
      }],
      tagActive: 0,
      symbolListShow: false,
      symbolList: [],
      symbolGoods: {
        name: "",
        last_price: "",
        change_value: "",
        change_rate: "",
        contract_type: "",
        exchange_code: "",
        ask_price: "",
        bid_price: "",
        symbol: "",
        contract_no: "",
        digits: 0,
        lot_max: "",
        lot_min: "",
        commodity_tick_size: "",
        level: 1,
        origin_symbol: ""
      },
      goodsShow: false,
      isHKList: false,
      HKT1: false,
      selectImg: require("@/assets/images/h5Page/select.png"),
      actionsType: [],
      actionsShow: false,
      actionsImg: require("@/assets/images/h5Page/result.png"),
      resultIsShow: -1,
      numCurrencyColumns: [{
        text: "按固定",
        value: 1
      },
        {
          text: "按倍数",
          value: 3
        },
        {
          text: "按资金占比(%)",
          value: 2
        }
      ],
      amount: "",
      orderShow: false,
      account_no: "",
      isBuy: true,
      showPopover: false,
      actionsGroup: [],
      isOver: true,
      isFocse: false,
      name: "",
      pre_code: "",
      order_qty: "",
      showPopoverN: false,
      tableList: [],
      tagShow: false,
      priceShow: true,
      loading: false,
      havePosition: true,
      groupObj: {},
      can_close_num: 0,
      can_close_numList: [],
      isOk: true,
      delPng: require("@/assets/images/h5Page/del_d.png"),
      adPng: require("@/assets/images/h5Page/add_d.png"),
      adPrPng: require("@/assets/images/h5Page/add_d.png"),
      delPrPng: require("@/assets/images/h5Page/del_d.png"),
      priceClick: false,
      numberClick: false,
      create_order: false,
      activeIcon: require("@/assets/images/h5Page/checked.png"),
      inactiveIcon: require("@/assets/images/h5Page/noCheck.png"),
      numberName: "按固定",
      numShow: false,
      resultNum: 1,
      accountShow: false,
      firstSubmit: true,
      account_list_order: []

    };
  },
  computed: {

    tickTimeText(){
      return (date_time_stamp) => {
        let text = new Date(Number(date_time_stamp));
        return formatDate(text, "hh:mm:ss");
      }
    },
    cPoorNetworkEnvironmentStatus() {
      return this.$store.state.network.v_poor_network_environment_status;
    },
    getnumCurrencyColumns() {
      if (this.form.way === 2) {
        return this.numCurrencyColumns = [{
          text: "按固定",
          value: 1
        },
          {
            text: "按资金占比(%)",
            value: 2
          }
        ];
      } else {
        return this.numCurrencyColumns = [{
          text: "按固定",
          value: 1
        },
          {
            text: "按倍数",
            value: 3
          },
          {
            text: "按资金占比(%)",
            value: 2
          }
        ];
      }
    }
  },
  async mounted() {
    bus.$on("onmessage", data => {
      
      this.getMsg(data);
    });

    this.startPageSwitchListener();

    await this.handAccount();
    this.handOrderAccount();
    this.handEx();
    // openWebSocket();
    if (!this.$route.meta.isH5Login) {
      Toast.setDefaultOptions({
        duration: 1500,
        closeOnClickOverlay: true,
        overlay: true
      });
    } else {
      Toast.resetDefaultOptions();
    }
    let old = this.$localstorage.get("oldList");
    // // 
    // setTimeout(() => {
    if(old && old.symbolData && old.symbolData.symbol){
      if (old && Number(old.way) === 1) {
        this.form.way = Number(old.way);
        this.form.account_group = Number(old.account_group);
        this.form.name_code = old.name_code;
        this.handSymbolClick(old.symbolData);
      } else if (old && Number(old.way) === 2) {
        this.form.way = Number(old.way);
        this.accountCurrencyColumns = [];
        this.$apis.h5PageGetAccount().then(res => {
          if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
            let cur = {};
            res.data.forEach(item => {
              let nItem = {
                text: `${item.futures_login_id}(${item.futures_name})`,
                value: item.id,
                id: item.group_id,
                name: item.futures_login_id,
                resultName: item.futures_name
              };
              this.accountCurrencyColumns.push(nItem);
              if (item.id == old.account_group) {
                cur = nItem;
              }
            });
            this.form.account_group = Number(old.account_group);
            this.form.name_code = old.name_code;
            if (old.symbolData.symbol) {
              this.handSymbolClick(old.symbolData);
            } else {
              this.handGroupChange(cur);
            }

          }
        });
      }
    }
    this.getAccountReverseOrder();
  },
  beforeDestroy() {
    // closeWebSocket();
    this.stopPageSwitchListener();
  },
  methods: {
    changeActiveTab(){
      if(this.symbolGoods && this.symbolGoods.symbol){
        let struct = {
          MsgType: "SubTicks",
          MsgBody: {
            symbol: this.symbolGoods.symbol
          }
        };
        this.$socket.sendMsg(struct);
      }
    },
    changeReverseOrder(){
      this.$store.commit('network/set_is_reverse_order', this.isReverse);
      this.$apis.setAccountReverseOrderApi({
        is_reverse_order: this.isReverse ? 1 : 0
      }).then(res =>{

      })
    },
    getAccountReverseOrder(){
      this.$apis.getAccountReverseOrderApi().then(res => {
        if(res.code == 0 && res.data){
          this.isReverse = res.data.is_reverse_order == 1;
          this.$store.commit('network/set_is_reverse_order', this.isReverse);
        }
      })
    },
    handClosePop() {
      this.showPopover = false;
      this.showPopoverN = false;
    },
    handClose() {
      this.isFocse = false;
      this.orderShow = false;
    },
    handOrderAccount() {
      this.account_list_order = [];
      this.$apis.getGroupList({
        show_account: 1,
        is_empty_hide: 1
      }).then(res => {
        if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
          res.data.forEach(item => {
            if (item.id === this.form.account_group) {
              // 
              this.account_list_order = item.account_list;
            }
          });
        } else if (res.code == 123 || res.code == 137) {
          Toast.fail(res.msg);
          setTimeout(() => {
            this.$router.push({
              name: "h5PageLogin"
            });
            localStorage.removeItem("token");
          }, 500);
        }

      }).catch(err => {});
    },
    handEx() {
      this.$apis.queryExchangeInfo().then(res => {

      }).catch(err => {

      });
    },
    handWayChange(e) {
      this.form = {
        way: 1,
        account_group: "",
        name_code: "",
        type: "",
        order_price: "",
        number: 1,
        numberText: "",
        typeValue: 50,
        group_type: ""
      };

      this.$localstorage.remove("oldList");


      this.symbolGoods.symbol = "";

      this.resultIsShow = 50;
      this.goodsShow = false;
      this.tagShow = false;

      this.isOver = true;
      this.priceShow = true;
      this.isFocse = false;

      this.symbolGoods.name = "";

      this.numberName = "按固定";
      this.resultNum = 1;

      this.form.way = e.value;
      this.accountCurrencyColumns = [];
      if (e.value === 1) {
        this.$apis.getGroupList({
          show_account: 1,
          is_empty_hide: 1
        }).then(res => {
          if (res.code === 0) {
            this.accountCurrencyColumns = [];
            res.data.forEach(item => {
              this.accountCurrencyColumns.push({
                text: item.group_name,
                value: item.id,
                id: item.id,
                list: item.account_list
              });

            });
            this.form.account_group = this.accountCurrencyColumns[0].value;
            this.groupObj = this.accountCurrencyColumns[0];

          } else if (res.code == 123 || res.code == 137) {
            Toast.fail(res.msg);
            setTimeout(() => {
              this.$router.push({
                name: "h5PageLogin"
              });
              localStorage.removeItem("token");
            }, 500);

          }

        }).catch(err => {});
      } else {
        this.$apis.h5PageGetAccount().then(res => {
          if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
            this.accountCurrencyColumns = [];
            res.data.forEach(item => {
              this.accountCurrencyColumns.push({
                text: `${item.futures_login_id}(${item.futures_name})`,
                value: item.id,
                id: item.group_id,
                name: item.futures_login_id,
                resultName: item.futures_name
              });
            });
            this.form.account_group = this.accountCurrencyColumns[0].value;
            this.groupObj = this.accountCurrencyColumns[0];


          } else if (res.code == 123 || res.code == 137) {
            Toast.fail(res.msg);
            setTimeout(() => {
              this.$router.push({
                name: "h5PageLogin"
              });
              localStorage.removeItem("token");
            }, 500);

          }

        });
      }
      this.account_list_order = [];
      this.handOrderAccount();
    },
    handGroupChange(e) {
      this.groupObj = e;
      this.form.group_type = e.id;
      this.form.account_group = e.value;

      if (this.symbolGoods.symbol && this.symbolGoods.contract_type == 84 && e.id !== 2) {
        this.symbolListShow = false;
        this.form.name_code = "";
        this.form.type = "";
        this.form.order_price = "";
        this.form.number = 1;
        this.form.numberText = "";
        this.form.typeValue = 50;
        this.symbolGoods.symbol = "";

        this.resultIsShow = 50;
        this.goodsShow = false;

        this.isOver = true;
        this.priceShow = true;

        this.tagActive = 0;
        this.tagShow = false;
        this.symbolGoods.name = "";
        this.isFocse = false;
        this.numberName = "按固定";
        this.resultNum = 1;
        this.$localstorage.remove("oldList");
      } else if (this.symbolGoods.symbol && this.symbolGoods.contract_type == 70 && e.id !== 1) {
        this.symbolListShow = false;
        this.form.name_code = "";
        this.form.type = "";
        this.form.order_price = "";
        this.form.number = 1;
        this.form.numberText = "";
        this.form.typeValue = 50;
        this.symbolGoods.symbol = "";

        this.resultIsShow = 50;
        this.goodsShow = false;

        this.isOver = true;
        this.priceShow = true;

        this.tagActive = 0;
        this.tagShow = false;
        this.symbolGoods.name = "";
        this.isFocse = false;
        this.numberName = "按固定";
        this.resultNum = 1;
        this.$localstorage.remove("oldList");
      } else {
        let oldList = {
          way: this.form.way,
          account_group: this.form.account_group,
          name_code: this.form.name_code,
          symbolData: this.symbolGoods
        };

        this.$localstorage.set("oldList", oldList);
      }

      if (this.form.way === 1) {
        this.actionsGroup = [];
        this.$apis.getGroupList({
          show_account: 2,
          is_empty_hide: 1
        }).then(res => {
          if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
            res.data.forEach(item => {
              if (item.id === e.value) {
                item.account_list.forEach(items => {
                  this.actionsGroup.push({
                    text: items.futures_login_id,
                    id: items.futures_name
                  });
                });


              }
            });
          } else if (res.code == 123 || res.code == 137) {
            Toast.fail(res.msg);
            setTimeout(() => {
              this.$router.push({
                name: "h5PageLogin"
              });
              localStorage.removeItem("token");
            }, 500);
          }

        }).catch(err => {});
      }

      if (this.form.account_group &&
        this.form.name_code &&
        this.form.order_price &&
        this.form.numberText
      ) {
        this.isOver = false;
      } else {
        this.isOver = true;
      }
      this.handOrderAccount();

    },
    async handAccount() {
      this.accountCurrencyColumns = [];
      await this.$apis.getGroupList({
        show_account: 1,
        is_empty_hide: 1
      }).then(res => {
        // // 
        if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
          res.data.forEach(item => {
            this.accountCurrencyColumns.push({
              text: item.group_name,
              value: item.id,
              id: item.id,
              list: item.account_list
            });
          });
        } else if (res.code == 123 || res.code == 137) {
          Toast.fail(res.msg);
          setTimeout(() => {
            this.$router.push({
              name: "h5PageLogin"
            });
            localStorage.removeItem("token");
          }, 500);
        }


        if (res.length > 1 && JSON.stringify(res.data) !== "{}") {
          this.form.account_group = res.data.find(item => item.id === 1).id;
          this.form.group_type = res.data.find(item => item.id === 1).id;
          this.groupObj = res.data.find(item => item.id === 1);

          this.groupObj = {
            text: res.data.find(item => item.id === 1).group_name,
            value: res.data.find(item => item.id === 1).id,
            id: res.data.find(item => item.id === 1).id,
            list: res.data.find(item => item.id === 1).account_list
          };
        } else if (JSON.stringify(res.data) !== "{}") {
          this.form.account_group = res.data[0].id;
          this.form.group_type = res.data[0].id;
          this.groupObj = {
            text: res.data[0].group_name,
            value: res.data[0].id,
            id: res.data[0].id,
            list: res.data[0].account_list
          };
        }

      }).catch(err => {

      });
      // setTimeout(() => {
      if (this.form.way === 1) {
        this.$apis.getGroupList({
          show_account: 2,
          is_empty_hide: 1
        }).then(res => {
          if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
            res.data.forEach(item => {
              if (item.id === this.form.group_type) {
                item.account_list.forEach(items => {
                  this.actionsGroup.push({
                    text: items.futures_login_id,
                    id: items.futures_name
                  });
                });
                let set = new Set(this.actionsGroup.map(item => item.id));
                let result = Array.from(set).map(id => this.actionsGroup
                  .find(item => item.id === id));
                this.actionsGroup = result;

              }
            });
          } else if (res.code == 123 || res.code == 137) {
            Toast.fail(res.msg);
            setTimeout(() => {
              this.$router.push({
                name: "h5PageLogin"
              });
              localStorage.removeItem("token");
            }, 500);
          }

        }).catch(err => {});
      }
      // }, 500)
      // // 
      if (this.form.account_group &&
        this.form.name_code &&
        this.form.order_price &&
        this.form.numberText
      ) {
        this.isOver = false;
      } else {
        this.isOver = true;
      }


    },
    handTag(data) {
      this.tagActive = data.id;
      this.isFocse = false;
      if (this.symbolGoods.last_price && this.symbolGoods.bid_price && this.symbolGoods.ask_price) {
        switch (data.id) {
          case 0:
            this.form.order_price = this.symbolGoods.last_price.toFixed(this.symbolGoods.digits);
            break;
          case 1:
            this.form.order_price = this.symbolGoods.bid_price.toFixed(this.symbolGoods.digits);
            break;
          case 2:
            this.form.order_price = this.symbolGoods.ask_price.toFixed(this.symbolGoods.digits);
            break;
          default:
            break;
        }
      }

      if (this.form.account_group &&
        this.form.name_code &&
        this.form.order_price &&
        this.form.numberText
      ) {
        this.isOver = false;
      } else {
        this.isOver = true;
      }


      this.handNumberChange();

    },
    // 数量增加
    handNumberAdd(e) {
      e.stopPropagation();
      if ((this.form.number == 1 || this.form.number == 3) && this.symbolGoods.symbol) {
        this.form.numberText = Number(this.form.numberText) + Number(this.symbolGoods.lot_min);
        this.delPng = require("@/assets/images/h5Page/del.png");
        this.numberClick = true;
        setTimeout(() => {
          // this.handNumberChange();
        }, 200);
      } else if (this.symbolGoods.symbol && this.form.number == 2) {
        this.delPng = require("@/assets/images/h5Page/del.png");
        this.numberClick = true;
        if (!this.form.numberText) {
          this.form.numberText = 0.01;
        } else if (this.form.numberText < 100) {
          this.form.numberText = parseFloat(this.form.numberText) + 0.01;
          setTimeout(() => {
            if (this.form.numberText == 100) {
              this.addPng = require("@/assets/images/h5Page/add_d.png");
              this.form.numberText = 100;
            }
          }, 200);
        } else if (this.form.numberText == 100) {
          this.addPng = require("@/assets/images/h5Page/add_d.png");
          this.form.numberText = 100;
        }
      }
    },

    // 数量减
    handNumberDel() {
      if ((this.form.number == 1 || this.form.number == 3) && this.numberClick) {
        if (Number(this.form.numberText) != Number(this.symbolGoods.lot_min)) {
          this.delPng = require("@/assets/images/h5Page/del.png");
          this.form.numberText = Number(this.form.numberText) - Number(this.symbolGoods.lot_min);
          setTimeout(() => {
            // this.handNumberChange();
          }, 200);
        }
        setTimeout(() => {
          if (Number(this.form.numberText) == Number(this.symbolGoods.lot_min)) {
            this.delPng = require("@/assets/images/h5Page/del_d.png");
            this.numberClick = false;
          }
        }, 200);
      } else if (this.symbolGoods.symbol && this.form.number == 2 && this.numberClick) {
        if (!this.form.numberText) {
          this.form.numberText = 0;
        } else if (this.form.numberText < 100 && this.form.numberText > 0) {
          this.form.numberText = parseFloat(this.form.numberText) - 0.01;
          setTimeout(() => {
            if (this.form.numberText == 0) {
              this.delPng = require("@/assets/images/h5Page/del_d.png");
              this.form.numberText = 0;
              this.numberClick = false;
            }
          }, 200);
        } else if (this.form.numberText == 0) {
          this.addPrPng = require("@/assets/images/h5Page/del_d.png");
          this.form.numberText = 0;
          this.numberClick = false;
        }
      }
    },
    // 价格加
    handPriceAdd() {
      if (this.symbolGoods.symbol) {
        let exchangeCode = [];
        let price = "";


        this.$apis.quoteQueryChangeunitApi().then(res => {
          res.infos.forEach(item => {
            exchangeCode.push(item.exchangeCode);
          });
          if (exchangeCode.findIndex(item => item === this.symbolGoods.exchange_code) > -1) {
            res.infos.forEach(item => {
              if (item.exchangeCode === this.symbolGoods.exchange_code && item.typ ===
                this.symbolGoods.contract_type) {
                item.rules.forEach(item1 => {
                  if ((parseFloat(this.form.order_price) > item1.begin ||
                    parseFloat(this.form.order_price) == item1.begin
                  ) && (parseFloat(this.form.order_price) < item1
                    .end || parseFloat(this.form.order_price) == item1
                    .end)) {
                    price = item1.changeUnit;
                  }
                });
              }
            });
            this.tagActive = -1;
          } else {
            price = this.symbolGoods.commodity_tick_size;
          }

          // 

          if (!this.form.order_price) {
            this.form.order_price = 0;
          }

          let x = String(price).indexOf(".") + 1;
          let y = String(price).length - x;

          if (x == 0) {
            // // 
            this.form.order_price = (parseFloat(this.form.order_price) + parseFloat(price))
              .toFixed(x);
            this.delPrPng = require("@/assets/images/h5Page/del.png");
            this.priceClick = true;
          } else if (y > 0) {
            // // 
            this.form.order_price = (parseFloat(this.form.order_price) + parseFloat(price))
              .toFixed(y);
            this.delPrPng = require("@/assets/images/h5Page/del.png");
            this.priceClick = true;
          }
          this.handNumberChange();

        });
      }


    },

    // 价格减
    handPriceDel() {
      if (this.symbolGoods.symbol && this.priceClick && this.form.order_price && this.form.order_price > 0) {
        let exchangeCode = [];
        let price = "";
        this.$apis.quoteQueryChangeunitApi().then(res => {
          res.infos.forEach(item => {
            exchangeCode.push(item.exchangeCode);
          });
          if (exchangeCode.findIndex(item => item === this.symbolGoods.exchange_code) > -1) {
            res.infos.forEach(item => {
              if (item.exchangeCode === this.symbolGoods.exchange_code && item.typ ===
                this.symbolGoods.contract_type) {
                item.rules.forEach(item1 => {
                  if ((parseFloat(this.form.order_price) > item1.begin ||
                    parseFloat(this.form.order_price) == item1.begin
                  ) && (parseFloat(this.form.order_price) < item1
                    .end || parseFloat(this.form.order_price) == item1
                    .end)) {
                    price = item1.changeUnit;
                  }
                });
              }
            });
            this.tagActive = -1;
          } else {
            price = this.symbolGoods.commodity_tick_size;
          }

          if (!this.form.order_price) {
            this.form.order_price = 0;
          }

          let x = String(price).indexOf(".") + 1;
          let y = String(price).length - x;

          if (parseFloat(this.form.order_price) != parseFloat(price)) {
            if (x == 0) {
              // // 
              this.form.order_price = (parseFloat(this.form.order_price) - parseFloat(price))
                .toFixed(x);
            } else if (y > 0) {
              // // 
              this.form.order_price = (parseFloat(this.form.order_price) - parseFloat(price))
                .toFixed(y);
            }
            this.handNumberChange();
            setTimeout(() => {
            }, 300);
          }


          setTimeout(() => {
            if (parseFloat(this.form.order_price) == parseFloat(price)) {
              this.delPrPng = require("@/assets/images/h5Page/del_d.png");
              this.priceClick = false;
            }
          }, 200);


        });
      }
    },


    handSymbolChange(e) {
      if (!e) {
        this.symbolListShow = false;
        this.goodsShow = false;
        this.symbolGoods = {
          name: "",
          last_price: "",
          change_value: "",
          change_rate: "",
          contract_type: "",
          exchange_code: "",
          ask_price: "",
          bid_price: "",
          symbol: "",
          contract_no: "",
          digits: 0,
          lot_max: "",
          lot_min: "",
          commodity_tick_size: "",
          level: 0
        };
        this.form.type = "";
        this.form.order_price = "";
        this.form.numberText = "";
        let oldList = {
          way: this.form.way,
          account_group: this.form.account_group,
          name_code: this.form.name_code,
          symbolData: this.symbolGoods
        };
        this.$localstorage.set("oldList", oldList);
      } else if (e) {
        this.symbolListShow = true;
        this.$apis.quoteSymbolApi({
          symbol: this.form.name_code,
          // contractType: !this.form.group_type ? 0 : this.form.group_type == 1 ? 70 : 84,
          limit: 100
        }).then(res => {
          if (res) {
            this.symbolList = res.infos;
          }
        });
        if (e) {
          this.$apis.quoteSymbolApi({
            symbol: this.form.name_code || 0,
            // contractType: !this.form.group_type ? 0 : this.form.group_type == 1 ? 70 : 84,
            limit: 100
          }).then(res => {
            if (res) {
              this.symbolList = res.infos;
            }
          });
        }


        // setTimeout(() => {


        // }, 500)


      } else {
        this.symbolListShow = false;
        this.goodsShow = false;
      }


      if (this.form.account_group &&
        this.form.name_code &&
        this.form.order_price &&
        this.form.numberText
      ) {
        this.isOver = false;
      } else {
        this.isOver = true;
      }

    },
    handSymbolClick(data) {
      this.form.name_code = data.origin_symbol;
      this.symbolListShow = false;
      this.symbolGoods.name = data.contract_name;
      this.goodsShow = true;
      this.symbolGoods.contract_type = data.contract_type;
      this.symbolGoods.exchange_code = data.exchange_code;
      this.symbolGoods.symbol = data.symbol;
      this.symbolGoods.commodity_no = data.commodity_no;
      this.symbolGoods.contract_no = data.contract_no;
      this.symbolGoods.digits = data.digits;
      this.symbolGoods.lot_min = data.lot_min;
      this.symbolGoods.lot_max = data.lot_max;
      this.symbolGoods.commodity_tick_size = data.commodity_tick_size;
      this.symbolGoods.origin_symbol = data.origin_symbol;
      this.form.numberText = data.lot_min;
      this.tagActive = 0;

      this.numberName = "按固定";
      this.resultNum = 1;

      this.form.number = 1;

      let oldList = {
        way: this.form.way,
        account_group: this.form.account_group,
        name_code: this.form.name_code,
        symbolData: data
      };
      this.$localstorage.set("oldList", oldList);

      this.adPng = require("@/assets/images/h5Page/add.png");
      this.adPrPng = require("@/assets/images/h5Page/add.png");
      this.priceClick = true;
      this.numberClick = true;
      this.isFocse = false;
      this.groupObj = {
        id: "",
        list: "",
        text: "",
        value: ""
      };

      if (this.form.way === 1) {
        if (data.contract_type == 84) {
          if (this.accountCurrencyColumns.find(item => item.id === 2)) {
            this.form.group_type = this.accountCurrencyColumns.find(item => item.id === 2).id;
            this.form.account_group = this.accountCurrencyColumns.find(item => item.id === 2).value;
            this.groupObj.id = this.accountCurrencyColumns.find(item => item.id === 2).id;
            this.groupObj.list = this.accountCurrencyColumns.find(item => item.id === 2).list;
            this.groupObj.text = this.accountCurrencyColumns.find(item => item.id === 2).text;
            this.groupObj.value = this.accountCurrencyColumns.find(item => item.id === 2).value;
            // 
            this.$apis.getGroupList({
              show_account: 2,
              is_empty_hide: 1
            }).then(res => {
              if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
                this.actionsGroup = [];
                res.data.forEach(item => {
                  if (item.id === this.accountCurrencyColumns.find(item => item
                    .id === 2).value) {
                    item.account_list.forEach(items => {
                      this.actionsGroup.push({
                        text: items.futures_login_id,
                        id: items.futures_name
                      });
                    });
                  }
                });

                let set = new Set(this.actionsGroup.map(item => item.id));
                let result = Array.from(set).map(id => this.actionsGroup.find(item => item
                  .id === id));
                setTimeout(() => {
                  this.actionsGroup = result;
                }, 200);
                //


              } else if (res.code == 123 || res.code == 137) {
                Toast.fail(res.msg);
                setTimeout(() => {
                  this.$router.push({
                    name: "h5PageLogin"
                  });
                  localStorage.removeItem("token");
                }, 500);
              }

            }).catch(err => {});
          } else {
            this.symbolGoods.last_price = "";
            this.symbolGoods.change_value = "";
            this.symbolGoods.change_rate = "";
            this.form.order_price = "";
            this.symbolGoods.bid_price = "";
            this.symbolGoods.ask_price = "";
            this.symbolGoods.pre_closing_price = "";
            this.form.name_code = "";
            this.goodsShow = false;
            return Toast.fail("当前没有可交易的账号");
          }
        } else if (data.contract_type == 70) {
          if (this.accountCurrencyColumns.find(item => item.id === 1)) {
            this.form.group_type = this.accountCurrencyColumns.find(item => item.id === 1).id;
            this.form.account_group = this.accountCurrencyColumns.find(item => item.id === 1).value;
            this.groupObj.id = this.accountCurrencyColumns.find(item => item.id === 1).id;
            this.groupObj.list = this.accountCurrencyColumns.find(item => item.id === 1).list;
            this.groupObj.text = this.accountCurrencyColumns.find(item => item.id === 1).text;
            this.groupObj.value = this.accountCurrencyColumns.find(item => item.id === 1).value;
            this.$apis.getGroupList({
              show_account: 2,
              is_empty_hide: 1
            }).then(res => {
              if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
                res.data.forEach(item => {
                  if (item.id === this.accountCurrencyColumns.find(item => item
                    .id === 1).value) {
                    item.account_list.forEach(items => {
                      this.actionsGroup.push({
                        text: items.futures_login_id,
                        id: items.futures_name
                      });
                    });
                  }
                });
                let set = new Set(this.actionsGroup.map(item => item.id));
                let result = Array.from(set).map(id => this.actionsGroup.find(item => item
                  .id === id));
                setTimeout(() => {
                  this.actionsGroup = result;
                }, 200);
              } else if (res.code == 123 || res.code == 137) {
                Toast.fail(res.msg);
                setTimeout(() => {
                  this.$router.push({
                    name: "h5PageLogin"
                  });
                  localStorage.removeItem("token");
                }, 500);
              }

            }).catch(err => {});
          } else {
            this.symbolGoods.last_price = "";
            this.symbolGoods.change_value = "";
            this.symbolGoods.change_rate = "";
            this.form.order_price = "";
            this.symbolGoods.bid_price = "";
            this.symbolGoods.ask_price = "";
            this.symbolGoods.pre_closing_price = "";
            this.form.name_code = "";
            this.goodsShow = false;
            return Toast.fail("当前没有可交易的账号");
          }

        }

      } else if (this.form.way === 2) {
        if (data.contract_type == 84) {
          if (!this.form.group_type || this.accountCurrencyColumns.find(item => item.value == this.form
            .account_group).id === 1) {
            if (this.accountCurrencyColumns.find(item => item.id === 2)) {
              this.form.group_type = this.accountCurrencyColumns.find(item => item.id === 2).id;
              this.form.account_group = this.accountCurrencyColumns.find(item => item.id === 2).value;
              this.groupObj.id = this.accountCurrencyColumns.find(item => item.id === 2).id;
              this.groupObj.name = this.accountCurrencyColumns.find(item => item.id === 2).name;
              this.groupObj.resultName = this.accountCurrencyColumns.find(item => item.id === 2)
                .resultName;
              this.groupObj.text = this.accountCurrencyColumns.find(item => item.id === 2).text;
              this.groupObj.value = this.accountCurrencyColumns.find(item => item.id === 2).value;
            } else {
              this.symbolGoods.last_price = "";
              this.symbolGoods.change_value = "";
              this.symbolGoods.change_rate = "";
              this.form.order_price = "";
              this.symbolGoods.bid_price = "";
              this.symbolGoods.ask_price = "";
              this.symbolGoods.pre_closing_price = "";
              this.form.name_code = "";
              this.goodsShow = false;
              return Toast.fail("当前没有可交易的账号");
            }
          } else {
            this.groupObj.id = this.accountCurrencyColumns.find(item => item.value == this.form
              .account_group).id;
            this.groupObj.name = this.accountCurrencyColumns.find(item => item.value == this.form
              .account_group).name;
            this.groupObj.resultName = this.accountCurrencyColumns.find(item => item.value == this.form
              .account_group).resultName;
            this.groupObj.text = this.accountCurrencyColumns.find(item => item.value == this.form
              .account_group).text;
            this.groupObj.value = this.accountCurrencyColumns.find(item => item.value == this.form
              .account_group).value;
          }
        } else if (data.contract_type == 70) {
          if (!this.form.group_type || this.accountCurrencyColumns.find(item => item.value == this.form
            .account_group).id === 2) {
            if (this.accountCurrencyColumns.find(item => item.id === 1)) {
              this.form.group_type = this.accountCurrencyColumns.find(item => item.id === 1).id;
              this.form.account_group = this.accountCurrencyColumns.find(item => item.id === 1).value;
              this.groupObj.id = this.accountCurrencyColumns.find(item => item.id === 1).id;
              this.groupObj.name = this.accountCurrencyColumns.find(item => item.id === 1).name;
              this.groupObj.resultName = this.accountCurrencyColumns.find(item => item.id === 1)
                .resultName;
              this.groupObj.text = this.accountCurrencyColumns.find(item => item.id === 1).text;
              this.groupObj.value = this.accountCurrencyColumns.find(item => item.id === 1).value;
            } else {
              this.symbolGoods.last_price = "";
              this.symbolGoods.change_value = "";
              this.symbolGoods.change_rate = "";
              this.form.order_price = "";
              this.symbolGoods.bid_price = "";
              this.symbolGoods.ask_price = "";
              this.symbolGoods.pre_closing_price = "";
              this.form.name_code = "";
              this.goodsShow = false;
              return Toast.fail("当前没有可交易的账号");
            }
          } else {
            this.groupObj.id = this.accountCurrencyColumns.find(item => item.value == this.form
              .account_group).id;
            this.groupObj.name = this.accountCurrencyColumns.find(item => item.value == this.form
              .account_group).name;
            this.groupObj.resultName = this.accountCurrencyColumns.find(item => item.value == this.form
              .account_group).resultName;
            this.groupObj.text = this.accountCurrencyColumns.find(item => item.value == this.form
              .account_group).text;
            this.groupObj.value = this.accountCurrencyColumns.find(item => item.value == this.form
              .account_group).value;
          }
        }
      }
      if(data.contract_type != 70){
        this.$apis.getQueryMarketPackageApi().then(result =>{

          if(result.infoS && result.infoS.length > 0){
            const filterData = result.infoS.filter(m => m.packageMarket === data.exchange_area);
            this.symbolGoods.level = filterData.length;
          }else{
            this.symbolGoods.level = 0;
          }
        })
      }

      let codeArray = [];
      this.$apis.queryExchangeInfo().then(res => {
        res.exchange_info.forEach(item => {
          codeArray.push(data.exchange_code);
          if (item.exchange_code == data.exchange_code) {
            this.symbolGoods.level = item.level;
          }
        });
      });

      if (this.form.way === 2 && data.contract_type === 84 && JSON.stringify(this.groupObj) !== "{}") {
        this.$apis.querybatchpos({
          account_nos: this.groupObj.name,
          page: 1,
          size: 1000,
          symbol: data.symbol,
          is_close: 1
        },{
          "get": {
            "X-channel-id": this.groupObj.id === 1 ? 1 : 2
          }
        }).then(res => {
          if (res.pos_infos.length === 0) {
            this.havePosition = true;
          } else {
            if (res.pos_infos[0].can_close_num > 0) {
              this.havePosition = false;
              this.can_close_num = res.pos_infos[0].can_close_num;
            } else {
              this.havePosition = true;
            }
          }
        });
      } else if (this.form.way === 1 && data.contract_type === 84) {
        let account_nos = "";
        if (JSON.stringify(this.groupObj) !== "{}") {
          this.groupObj.list.forEach(item => {
            account_nos += item + ",";
          });
          this.$apis.querybatchpos({
            account_nos: account_nos,
            page: 1,
            size: 1000,
            symbol: data.symbol,
            is_close: 1
          },{
            "get": {
              "X-channel-id": this.groupObj.id === 1 ? 1 : 2
            }
          }).then(res => {
            if (res.pos_infos.length === 0) {
              this.havePosition = true;
            } else {
              let result = [];
              let resultList = [];
              res.pos_infos.forEach(item => {
                result.push(item.can_close_num);
                resultList.push({
                  account_no: item.account_no,
                  can_close_num: item.can_close_num
                });
              });

              let huSum = result.every((x, y, z) => {
                return x == 0;
              });

              if (huSum) {
                this.havePosition = true;
              } else {
                this.havePosition = false;
                this.can_close_numList = resultList;
              }
            }
          });
        }

      } else if (data.contract_type === 70) {
        this.havePosition = false;
      } else {
        this.havePosition = true;
      }


      if (this.symbolGoods.symbol) {
        this.form.type = "限价单";
      }

      this.resultIsShow = 50;
      this.form.typeValue = 50;
      this.$apis.future_ticksnapshot({
        symbol: data.symbol
      }).then(res => {
        if (res.future_ticks.length !== 0) {
          this.symbolGoods.last_price = res.future_ticks[0].last_price;
          this.symbolGoods.change_value = res.future_ticks[0].change_value;
          this.symbolGoods.change_rate = res.future_ticks[0].change_rate;
          this.symbolGoods.date_time_stamp = res.future_ticks[0].date_time_stamp;
          this.form.order_price = res.future_ticks[0].last_price.toFixed(this.symbolGoods.digits);
          if (res.future_ticks[0].bid_price.length !== 0) {
            this.symbolGoods.bid_price = res.future_ticks[0].bid_price[0];
          }
          if (res.future_ticks[0].ask_price.length !== 0) {
            this.symbolGoods.ask_price = res.future_ticks[0].ask_price[0];
          }

          const msg = res.future_ticks[0];
          if ((msg.bid_price && msg.bid_price.length !== 0) && (msg.ask_price && msg.ask_price.length !== 0)) {
            this.tagList = [{
              id: 0,
              name: "最新价"
            }, {
              id: 1,
              name: "排队价"
            }, {
              id: 2,
              name: "对手价"
            }];
          } else if ((!msg.bid_price || msg.bid_price.length === 0) && (msg.ask_price && msg.ask_price.length !== 0)) {
            this.tagList = [{
              id: 0,
              name: "最新价"
            }, {
              id: 2,
              name: "对手价"
            }];
          } else if ((msg.bid_price && msg.bid_price.length !== 0) && (!msg.ask_price || msg.ask_price.length === 0)) {
            this.tagList = [{
              id: 0,
              name: "最新价"
            }, {
              id: 1,
              name: "排队价"
            }];
          } else if ((!msg.bid_price || msg.bid_price.length === 0) && (!msg.ask_price || msg.ask_price.length === 0)) {
            this.tagList = [{
              id: 0,
              name: "最新价"
            }];
          }


          this.symbolGoods.pre_closing_price = res.future_ticks[0].pre_closing_price;
          this.tagShow = true;
          this.delPrPng = require("@/assets/images/h5Page/del.png");


        } else {
          this.symbolGoods.last_price = "";
          this.symbolGoods.change_value = "";
          this.symbolGoods.change_rate = "";
          this.form.order_price = "";
          this.symbolGoods.bid_price = "";
          this.symbolGoods.ask_price = "";
          this.symbolGoods.pre_closing_price = "";
          // this.tagActive = -1
          this.tagShow = false;
        }

        if (data.symbol) {
          let struct = {
            MsgType: "SubTicks",
            MsgBody: {
              symbol: data.symbol
            }
          };
          this.$socket.sendMsg(struct);
          // sendSock(struct);
          // getSock(this.getMsg);
        }

        this.handNumberChange();
      });
      // setTimeout(() => {
      // 	this.handNumberChange();
      // }, 200)
      setTimeout(() => {
        if (this.form.account_group &&
          this.form.name_code &&
          this.form.order_price &&
          this.form.numberText
        ) {
          this.isOver = false;
        } else {
          this.isOver = true;
        }
      }, 500);
      this.handOrderAccount();


    },

    getMsg(msg) {
      if (this.symbolGoods.symbol === msg.symbol && msg.last_price) {
        if (this.form.typeValue === 50 || this.form.typeValue === 72) {
          this.tagShow = true;
        } else if (this.form.typeValue === 49 || this.form.typeValue === 71) {
          this.tagShow = false;
        }
        this.symbolGoods.last_price = msg.last_price;
        this.symbolGoods.date_time_stamp = msg.date_time_stamp;
        if (msg.change_value) {
          this.symbolGoods.change_value = msg.change_value;
        }
        if (msg.change_rate) {
          this.symbolGoods.change_rate = msg.change_rate;
        }

        if (msg.bid_price && !this.isFocse) {
          this.symbolGoods.bid_price = msg.bid_price[0];
        }
        if (msg.ask_price && !this.isFocse) {
          this.symbolGoods.ask_price = msg.ask_price[0];
        }

        if ((msg.bid_price && msg.bid_price.length !== 0) && (msg.ask_price && msg.ask_price.length !== 0)) {
          this.tagList = [{
            id: 0,
            name: "最新价"
          }, {
            id: 1,
            name: "排队价"
          }, {
            id: 2,
            name: "对手价"
          }];
        } else if ((!msg.bid_price || msg.bid_price.length === 0) && (msg.ask_price && msg.ask_price.length !== 0)) {
          this.tagList = [{
            id: 0,
            name: "最新价"
          }, {
            id: 2,
            name: "对手价"
          }];
        } else if ((msg.bid_price && msg.bid_price.length !== 0) && (!msg.ask_price || msg.ask_price.length === 0)) {
          this.tagList = [{
            id: 0,
            name: "最新价"
          }, {
            id: 1,
            name: "排队价"
          }];
        } else if ((!msg.bid_price || msg.bid_price.length === 0) && (!msg.ask_price || msg.ask_price.length === 0)) {
          this.tagList = [{
            id: 0,
            name: "最新价"
          }];
        }

        this.symbolGoods.pre_closing_price = msg.pre_closing_price;
        if(msg.commodity_no){
          this.symbolGoods.commodity_no = msg.commodity_no;
        }
        if(msg.contract_no){
          this.symbolGoods.contract_no = msg.contract_no;
        }


        // 
        if (!this.isFocse) {
          if (this.tagActive === 0) {
            this.form.order_price = msg.last_price.toFixed(this.symbolGoods.digits);
            if (this.symbolGoods.contract_type === 84) {
              this.amount = (parseFloat(msg.last_price) * parseFloat(this.form.numberText)).toFixed(2);
            }
            this.delPrPng = require("@/assets/images/h5Page/del.png");
          } else if (this.tagActive === 1) {
            if(msg.bid_price && msg.bid_price.length > 0){
              this.form.order_price = msg.bid_price[0].toFixed(this.symbolGoods.digits);
              if (this.symbolGoods.contract_type === 84) {
                this.amount = (parseFloat(msg.bid_price[0]) * parseFloat(this.form.numberText)).toFixed(2);
              }
            }
            this.delPrPng = require("@/assets/images/h5Page/del.png");
          } else if (this.tagActive === 2) {
            this.form.order_price = msg.ask_price[0].toFixed(this.symbolGoods.digits);
            if (this.symbolGoods.contract_type === 84) {
              this.amount = (parseFloat(msg.ask_price[0]) * parseFloat(this.form.numberText)).toFixed(2);
            }
            this.delPrPng = require("@/assets/images/h5Page/del.png");
          }
          if ((this.form.typeValue === 49 || this.form.typeValue === 71) && this.symbolGoods
            .contract_type === 84) {
            this.amount = (parseFloat(msg.last_price) * parseFloat(this.form.numberText) * 1.2).toFixed(2);
          }
        }
        setTimeout(() => {
          if (this.form.account_group &&
            this.form.name_code &&
            this.form.order_price &&
            this.form.numberText
          ) {
            this.isOver = false;
          } else {
            this.isOver = true;
          }
        }, 500);
      }
    },


    handTypeChange() {
      if (!this.symbolGoods.symbol) return false;
      this.actionsShow = true;
      if (this.symbolGoods.contract_type === 70) {
        if(this.hasAuction.includes(this.symbolGoods.commodity_no)){
          this.actionsType = [
            {
              name: "限价单",
              value: 50
            },{
              name: "竞价市价单",
              value: 66
            }];
        }else{
          this.actionsType = [{
            name: "限价单",
            value: 50
          }];
        }

      } else if (this.symbolGoods.contract_type !== 70 && this.symbolGoods.exchange_code === "HKSE") {
        this.actionsType = [{
          name: "限价单",
          value: 50
        }, {
          name: "市价单",
          value: 49
        }, {
          name: "竞价限价单",
          value: 72
        }, {
          name: "竞价市价单",
          value: 71
        }];
      } else if (this.symbolGoods.contract_type !== 70 && (this.symbolGoods.exchange_code === "AMEX" || this
        .symbolGoods.exchange_code === "NASDAQ" || this.symbolGoods.exchange_code === "NYSE")) {
        this.actionsType = [{
          name: "限价单",
          value: 50
        }, {
          name: "市价单",
          value: 49
        }];
      }
      if (this.form.account_group &&
        this.form.name_code &&
        this.form.order_price &&
        this.form.numberText
      ) {
        this.isOver = false;
      } else {
        this.isOver = true;
      }

      // 


    },
    handATypeChange(data) {
      if (this.form.account_group &&
        this.form.name_code &&
        this.form.order_price &&
        this.form.numberText
      ) {
        this.isOver = false;
      } else {
        this.isOver = true;
      }
      this.actionsShow = false;
      this.resultIsShow = data.value;
      this.form.type = data.name;
      this.form.typeValue = data.value;
      if(this.form.typeValue != 66){
        this.tagShow = true;
      }else{
        this.tagShow = false;
      }

      this.numberName = "按固定";
      this.resultNum = 1;
      this.form.number = 1;

      this.form.numberText = this.symbolGoods.lot_min;

      // let old = this.$localstorage.get("oldList")
      // this.handSymbolClick(old.symbolData)


      if ((this.form.typeValue === 49 || this.form.typeValue === 71 || this.form.typeValue === 66) && !this.symbolGoods.last_price) {
        this.priceShow = false;
        this.form.order_price = "0";
      } else if ((this.form.typeValue === 49 || this.form.typeValue === 71 || this.form.typeValue === 66) && this.symbolGoods.last_price) {
        this.priceShow = false;
      } else {
        this.priceShow = true;
        // this.form.order_price = ''
      }


      if (this.form.numberText && this.symbolGoods.contract_type === 84 && this.form.number === 1) {
        if (this.form.typeValue === 50 || this.form.typeValue === 72) {
          this.amount = parseFloat(this.form.order_price * this.form.numberText);
        } else if (this.form.typeValue === 49 || this.form.typeValue === 71) {
          this.tagShow = false;
          // this.amount = (parseFloat(this.form.order_price) * parseFloat(this.form.numberText) * 1.2).toFixed(2)
          if (this.symbolGoods.last_price) {
            this.amount = (parseFloat(this.symbolGoods.last_price) * parseFloat(this.form.numberText) *
              1.2).toFixed(2);
          } else {
            this.amount = (parseFloat(this.symbolGoods.pre_closing_price) * parseFloat(this.form
              .numberText) * 1.2).toFixed(2);
          }
        }
      } else if (this.form.numberText && this.symbolGoods.contract_type === 70) {
        if (this.form.way !== 1) {
          let account_no = "";
          this.accountCurrencyColumns.forEach(item => {
            if (item.value === this.form.account_group) {
              account_no = item.name;
            }
          });
          if (account_no) {
            this.$apis.quoteQryAccountMarginRentApi({
              account_no: account_no,
              commodity_no: this.symbolGoods.commodity_no
            }).then(res => {
              if ((res && res.account_margin_rents) && res.account_margin_rents.length > 0) {
                if (res.account_margin_rents[0].calculate_mode === 50) {
                  this.amount = parseFloat(this.form.numberText * res.account_margin_rents[0]
                    .initial_margin);
                } else {
                  // this.amount = parseFloat(this.form.numberText * res.data.account_margin_rents[0].initial_margin)
                }
              }
            });
          }

        } else if (this.form.way === 1 && this.form.number == 2) {
          let account_no = "";
          this.accountCurrencyColumns.forEach(item => {
            if (item.value === this.form.account_group) {
              account_no = item.name;
            }
          });
          if (account_no) {
            this.$apis.quoteQryAccountMarginRentApi({
              account_no: account_no,
              commodity_no: this.symbolGoods.commodity_no
            }).then(res => {
              if ((res && res.account_margin_rents) && res.account_margin_rents.length > 0) {
                if (res.account_margin_rents[0].calculate_mode === 50) {
                  this.amount = parseFloat(res.account_margin_rents[0].initial_margin);
                } else {
                  // this.amount = parseFloat(this.form.numberText * res.data.account_margin_rents[0].initial_margin)
                }
              }
            });
          }

        } else if (this.form.way === 2 && this.form.number == 2) {
          let account_no = "";
          this.accountCurrencyColumns.forEach(item => {
            if (item.value === this.form.account_group) {
              account_no = item.name;
            }
          });
          if (account_no) {
            this.$apis.quoteQryAccountMarginRentApi({
              account_no: account_no,
              commodity_no: this.symbolGoods.commodity_no
            }).then(res => {
              if ((res && res.account_margin_rents) && res.account_margin_rents.length > 0) {
                if (res.account_margin_rents[0].calculate_mode === 50) {
                  this.amount = parseFloat(res.account_margin_rents[0].initial_margin);
                } else {
                  // this.amount = parseFloat(this.form.numberText * res.data.account_margin_rents[0].initial_margin)
                }
              }
            });
          }

        } else {
          let account_no = "";
          this.$apis.getGroupList({
            show_account: 1,
            is_empty_hide: 1
          }).then(res => {
            if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
              res.data.forEach(item => {
                if (item.id === this.form.account_group) {
                  account_no = item.account_list[0];
                }
              });
            } else if (res.code == 123 || res.code == 137) {
              Toast.fail(res.msg);
              setTimeout(() => {
                this.$router.push({
                  name: "h5PageLogin"
                });
                localStorage.removeItem("token");
              }, 500);
            }
            this.$apis.quoteQryAccountMarginRentApi({
              account_no: account_no,
              commodity_no: this.symbolGoods.commodity_no
            }).then(res => {
              if ((res && res.account_margin_rents) && res.account_margin_rents.length > 0) {
                if (res.account_margin_rents[0].calculate_mode === 50) {
                  this.amount = parseFloat(this.form.numberText * res
                    .account_margin_rents[0]
                    .initial_margin);
                } else {
                  // this.amount = parseFloat(this.form.numberText * res.data.account_margin_rents[0].initial_margin)
                }
              }

            });


          }).catch(err => {});
        }


      }
    },
    handNumberChange() {
      if (this.form.number === 2) {
        if (this.form.numberText < 0) {
          this.form.numberText = 0;
        } else if (this.form.numberText > 100) {
          this.form.numberText = 100;
        }
        if (this.form.numberText > 0) {
          this.delPng = require("@/assets/images/h5Page/del.png");
        } else {
          this.delPng = require("@/assets/images/h5Page/del_d.png");
        }
      }
      const { digits = 0 } = this.symbolGoods;
      if (this.tagActive === 0) {
        if (parseFloat(this.form.order_price) && parseFloat(this.symbolGoods.last_price)){
          if (parseFloat(this.form.order_price).toFixed(digits) != parseFloat(this.symbolGoods.last_price).toFixed(digits)) {
            this.isFocse = true;
          } else {
            this.isFocse = false;
          }
        }
      } else if (this.tagActive === 1) {
        if (parseFloat(this.form.order_price) && parseFloat(this.symbolGoods.bid_price)){
          if (parseFloat(this.form.order_price).toFixed(digits) != parseFloat(this.symbolGoods.bid_price).toFixed(digits)) {
            this.isFocse = true;
          } else {
            this.isFocse = false;
          }
        }

      } else if (this.tagActive === 2) {
        if (parseFloat(this.form.order_price) && parseFloat(this.symbolGoods.ask_price)){
          if (parseFloat(this.form.order_price).toFixed(digits) != parseFloat(this.symbolGoods.ask_price).toFixed(digits)) {
            this.isFocse = true;
          } else {
            this.isFocse = false;
          }
        }

      }
      this.$nextTick(() =>{
        if (this.isFocse) {
          this.tagActive = -1;
        }
      })


      if (this.form.account_group &&
        this.form.name_code &&
        this.form.order_price &&
        this.form.numberText
      ) {
        this.isOver = false;
      } else {
        this.isOver = true;
      }
      if (this.form.numberText && this.symbolGoods.contract_type === 84) {
        if (this.form.typeValue === 50 || this.form.typeValue === 72) {
          this.amount = parseFloat(this.form.order_price * this.form.numberText).toFixed(2);
        } else if (this.form.typeValue === 49 || this.form.typeValue === 71) {
          this.tagShow = false;
          // this.amount = (parseFloat(this.form.order_price) * parseFloat(this.form.numberText) * 1.2).toFixed(2)
          if (this.symbolGoods.last_price) {
            this.amount = (parseFloat(this.symbolGoods.last_price) * parseFloat(this.form.numberText) *
              1.2).toFixed(2);
          } else {
            this.amount = (parseFloat(this.symbolGoods.pre_closing_price) * parseFloat(this.form
              .numberText) * 1.2).toFixed(2);
          }
        }
      } else if (this.form.numberText && this.symbolGoods.contract_type === 70) {
        if (this.form.way !== 1) {
          let account_no = "";
          this.accountCurrencyColumns.forEach(item => {
            if (item.value === this.form.account_group) {
              account_no = item.name;
            }
          });
          if (account_no) {
            this.$apis.quoteQryAccountMarginRentApi({
              account_no: account_no,
              commodity_no: this.symbolGoods.commodity_no
            }).then(res => {
              if ((res && res.account_margin_rents) && res.account_margin_rents.length > 0) {
                if (res.account_margin_rents[0].calculate_mode === 50) {
                  this.amount = parseFloat(this.form.numberText * res.account_margin_rents[0]
                    .initial_margin);
                } else {
                  // this.amount = parseFloat(this.form.numberText * res.data.account_margin_rents[0].initial_margin)
                }
              }
            }).catch(err => {});
          }

        } else if (this.form.way === 1 && this.form.number == 2) {
          let account_no = "";
          this.accountCurrencyColumns.forEach(item => {
            if (item.value === this.form.account_group) {
              account_no = item.name;
            }
          });
          if (account_no) {
            this.$apis.quoteQryAccountMarginRentApi({
              account_no: account_no,
              commodity_no: this.symbolGoods.commodity_no
            }).then(res => {
              if ((res && res.account_margin_rents) && res.account_margin_rents.length > 0) {
                if (res.account_margin_rents[0].calculate_mode === 50) {
                  this.amount = parseFloat(res.account_margin_rents[0].initial_margin);
                } else {
                  // this.amount = parseFloat(this.form.numberText * res.data.account_margin_rents[0].initial_margin)
                }
              }
            });
          }

        } else if (this.form.way === 2 && this.form.number == 2) {
          let account_no = "";
          this.accountCurrencyColumns.forEach(item => {
            if (item.value === this.form.account_group) {
              account_no = item.name;
            }
          });
          if (account_no) {
            this.$apis.quoteQryAccountMarginRentApi({
              account_no: account_no,
              commodity_no: this.symbolGoods.commodity_no
            }).then(res => {
              if ((res && res.account_margin_rents) && res.account_margin_rents.length > 0) {
                if (res.account_margin_rents[0].calculate_mode === 50) {
                  this.amount = parseFloat(res.account_margin_rents[0].initial_margin);
                } else {
                  // this.amount = parseFloat(this.form.numberText * res.data.account_margin_rents[0].initial_margin)
                }
              }
            });
          }

        } else {
          let account_no = "";
          this.$apis.getGroupList({
            show_account: 1,
            is_empty_hide: 1
          }).then(res => {
            if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
              res.data.forEach(item => {
                if (item.id === this.form.account_group) {
                  account_no = item.account_list[0];
                }
              });
            } else if (res.code == 123 || res.code == 137) {
              Toast.fail(res.msg);
              setTimeout(() => {
                this.$router.push({
                  name: "h5PageLogin"
                });
                localStorage.removeItem("token");
              }, 500);
            }
            this.$apis.quoteQryAccountMarginRentApi({
              account_no: account_no,
              commodity_no: this.symbolGoods.commodity_no
            }).then(res => {
              if ((res && res.account_margin_rents) && res.account_margin_rents.length > 0) {
                if (res.account_margin_rents[0].calculate_mode === 50) {
                  this.amount = parseFloat(this.form.numberText * res
                    .account_margin_rents[0]
                    .initial_margin);
                } else {
                  // this.amount = parseFloat(this.form.numberText * res.data.account_margin_rents[0].initial_margin)
                }
              }
            }).catch(err => {});

          }).catch(err => {});
        }
      }
    },

    handCurryChange(e) {
      // this.form.number = e.value
      // this.numberClick = true
      // if (e.value === 1) {
      // 	this.form.numberText = this.symbolGoods.lot_min
      // } else {
      // 	this.form.numberText = ''
      // }
      this.numShow = true;

    },

    handACurryChange(e) {
      this.resultNum = e.value;
      this.form.number = e.value;
      this.numShow = false;
      this.numberName = e.text;
      this.numberClick = true;
      if (e.value === 1 || e.value === 3) {
        this.form.numberText = this.symbolGoods.lot_min;
      } else {
        this.form.numberText = "";
      }
    },
    // 下单
    newSubmitOrder(type){
      // type: 1 - 买  2 - 卖
      // 是否是反向
      if(this.isReverse){
        if(type == 1){
          this.handSell();
        }else{
          this.handBuy();
        }
      }else{
        if(type == 1){
          this.handBuy();
        }else{
          this.handSell();
        }
      }
    },

    handBuy(e) {
      // this.clickTime = new Date().getTime();
      // 
      this.orderShow = false;
      let numPattern = /^-?\d*\.?\d+$/;

      let numSl = /^[0-9]\d*$/;

      if (this.form.order_price && !numPattern.test(this.form.order_price)) {
        return Toast.fail("价格只可以输入数字或小数");
      }
      if (this.form.number === 1 || this.form.number === 3) {
        if (parseFloat(this.form.numberText) % parseFloat(this.symbolGoods.lot_min) !== 0) {
          return Toast.fail("请输入正确的数量");
        }
      }
      if (!this.form.numberText) {
        return Toast.fail("请输入正确的数量");
      }


      let price = "";
      let exchangeCode = [];
      let m = "";

      Toast.loading({
        // mask: true, //蒙层
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中..."
      });
      this.$apis.quoteQueryChangeunitApi().then(res => {
        res.infos.forEach(item => {
          exchangeCode.push(item.exchangeCode);
        });
        if (exchangeCode.findIndex(item => item === this.symbolGoods.exchange_code) > -1) {
          res.infos.forEach(item => {
            exchangeCode.push(item.exchangeCode);
            if (item.exchangeCode === this.symbolGoods.exchange_code && item.typ ===
              this.symbolGoods.contract_type) {
              item.rules.forEach(item1 => {
                if ((parseFloat(this.form.order_price) > item1.begin ||
                  parseFloat(this.form.order_price) == item1.begin) && (
                  parseFloat(this.form.order_price) < item1.end ||
                  parseFloat(this.form.order_price) == item1.end)) {
                  price = parseFloat(this.form.order_price) / (parseFloat(
                    item1.changeUnit));
                  m = parseFloat(item1.changeUnit);

                }

              });
              if (parseFloat(this.form.order_price) > item.rules[item.rules.length - 1]
                .end) {
                price = parseFloat(this.form.order_price) / (parseFloat(
                  item.rules[item.rules.length - 1].changeUnit));
              }

            }
          });
        } else {
          price = parseFloat(this.form.order_price) / (parseFloat(this.symbolGoods
            .commodity_tick_size));
          m = parseFloat(this.symbolGoods.commodity_tick_size);
        }


        // 
        // if(!price){
        // 	Toast.fail("请输入正确的价格")
        // 	setTimeout(() =>{
        // 		return Toast.clear();
        // 	},500)
        // }
        if ((parseFloat(this.form.order_price) % m).toFixed(5) != 0) {
          if (price && (parseFloat(this.form.order_price) % m).toFixed(5) != m) {
            this.isOk = false;
            return Toast.fail("请输入正确的价格");
          } else {
            this.isOk = true;
            // 只有正确后才能调取
            this.handBuyOk();
          }
        } else {
          this.isOk = true;
          // 只有正确后才能调取
          this.handBuyOk();
        }
      });
      if (this.form.way === 1) {
        this.accountCurrencyColumns.forEach(item => {
          if (item.value === this.form.account_group) {
            this.account_no = item.text;
            this.name = item.text;
          }
        });
      } else {
        this.accountCurrencyColumns.forEach(item => {
          if (item.value === this.form.account_group) {
            this.account_no = item.name;
            this.name = item.resultName;
          }
        });
      }
      this.isBuy = true;
    },
    // 成功后才能调取
    handBuyOk() {
      let obj = this.$localstorage.get("openObj");
      if (obj) {
        this.create_order = obj.create_order == 0 ? true : false;
        if (obj.create_order == 1) {
          this.orderShow = true;
          if (this.isOk) {
            if (this.form.number === 2 && this.form.way === 2) {
              Toast.loading({
                // mask: true, //蒙层
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "加载中..."
              });
              let params = {
                margin_ratio: parseFloat(parseFloat(this.form.numberText) /
                  100),
                order_method: 2,
                volume_mode: 1,
                orders: [{
                  account_no: this.account_no,
                  exchange_no: this.symbolGoods.exchange_code,
                  commodity_no: this.symbolGoods.commodity_no,
                  contract_no: this.symbolGoods.contract_no,
                  commodity_type: JSON.stringify(this.symbolGoods
                    .contract_type),
                  order_side: this.isBuy ? "66" : "83",
                  order_type: JSON.stringify(this.form.typeValue),
                  order_price: this.tagActive == 1 && !this.isBuy ? this
                    .symbolGoods.ask_price.toFixed(this.symbolGoods
                      .digits) : this.tagActive == 2 && !this.isBuy ?
                    this
                      .symbolGoods.bid_price.toFixed(this.symbolGoods
                      .digits) : this.form.order_price,
                  order_qty: "1",
                  addone_isvalid: this.HKT1 ? "1" : "0"
                }],
                name: this.name
              };
              if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
                params.orders.forEach(oItem => {
                  delete oItem.order_price;
                });
              }
              // 
              this.$apis.v1PrebatchorderApi(params, {
                "post": {
                  "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2
                }
              }).then(res => {
                if (res.error_code === 0) {
                  Toast.clear();
                  this.orderShow = true;
                  this.pre_code = res.code;
                  this.order_qty = res.orders[0].order_qty;
                  this.tableList = res.orders;
                  this.isFocse = true;
                  this.firstSubmit = true;
                } else {
                  Toast.fail(res.error_msg);
                  this.firstSubmit = false;
                  setTimeout(() => {
                    Toast.clear();
                  }, 1500);
                }
              }).catch((e) => {
                Toast.fail(e.error_msg);
                Toast.clear();
              });

            } else if (this.form.number === 2 && this.form.way === 1) {
              this.orderShow = false;
              Toast.loading({
                // mask: true, //蒙层
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "加载中..."
              });
              let params = {};
              let account_list = [];
              params = {
                margin_ratio: parseFloat(parseFloat(this.form
                  .numberText) / 100),
                order_method: 1,
                account_group_Id: this.form.account_group,
                orders: [],
                name: this.name,
                volume_mode: 1
              };
              this.account_list_order.forEach(item => {
                params.orders.push({
                  account_no: item,
                  exchange_no: this.symbolGoods
                    .exchange_code,
                  commodity_no: this.symbolGoods
                    .commodity_no,
                  contract_no: this.symbolGoods
                    .contract_no,
                  commodity_type: JSON.stringify(this
                    .symbolGoods.contract_type
                  ),
                  order_side: this.isBuy ? "66" : "83",
                  order_type: JSON.stringify(this
                    .form.typeValue),
                  order_price: this.tagActive == 1 && !this
                    .isBuy ? this.symbolGoods.ask_price
                      .toFixed(this.symbolGoods.digits) :
                    this.tagActive == 2 && !this.isBuy ?
                      this.symbolGoods.bid_price.toFixed(this
                        .symbolGoods.digits) : this.form
                        .order_price,
                  order_qty: "1",
                  addone_isvalid: this.HKT1 ? "1" : "0"
                });
              });
              // 
              if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
                params.orders.forEach(oItem => {
                  delete oItem.order_price;
                });
              }
              this.$apis.v1PrebatchorderApi(params,{
                "post": {
                  "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2
                }
              }).then(res => {
                if (res.error_code === 0) {
                  Toast.clear();
                  this.orderShow = true;
                  this.pre_code = res.code;
                  this.order_qty = res.orders[0].order_qty;
                  this.tableList = res.orders;
                  this.isFocse = true;
                  this.firstSubmit = true;
                } else {
                  Toast.fail(res.error_msg);
                  this.firstSubmit = false;
                  setTimeout(() => {
                    Toast.clear();
                  }, 1500);
                }
              }).catch(err => {
                Toast.fail(err.error_msg);
                Toast.clear();
              });

              setTimeout(() => {

              }, 500);


            } else if (this.form.number === 3 && this.form.way === 1) {
              Toast.loading({
                // mask: true, //蒙层
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "加载中..."
              });
              let params = {};
              let account_list = [];
              params = {
                margin_ratio: parseFloat(parseFloat(this.form
                  .numberText) / 100),
                order_method: 1,
                account_group_Id: this.form.account_group,
                orders: [],
                name: this.name,
                volume_mode: 2
              };
              this.account_list_order.forEach(item => {
                params.orders.push({
                  account_no: item,
                  exchange_no: this.symbolGoods
                    .exchange_code,
                  commodity_no: this.symbolGoods
                    .commodity_no,
                  contract_no: this.symbolGoods
                    .contract_no,
                  commodity_type: JSON.stringify(this
                    .symbolGoods.contract_type
                  ),
                  order_side: this.isBuy ? "66" : "83",
                  order_type: JSON.stringify(this
                    .form.typeValue),
                  order_price: this.tagActive == 1 && !this
                    .isBuy ? this.symbolGoods.ask_price
                      .toFixed(this.symbolGoods.digits) :
                    this.tagActive == 2 && !this.isBuy ?
                      this.symbolGoods.bid_price.toFixed(this
                        .symbolGoods.digits) : this.form
                        .order_price,
                  order_qty: this.form.numberText,
                  addone_isvalid: this.HKT1 ? "1" : "0"
                });
              });
              // 
              if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
                params.orders.forEach(oItem => {
                  delete oItem.order_price;
                });
              }
              this.$apis.v1PrebatchorderApi(params,{
                "post": {
                  "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2
                }
              }).then(res => {
                if (res.error_code === 0) {
                  Toast.clear();
                  this.orderShow = true;
                  this.pre_code = res.code;
                  this.order_qty = res.orders[0].order_qty;
                  this.tableList = res.orders;
                  this.isFocse = true;
                  this.firstSubmit = false;
                } else {
                  Toast.fail(res.error_msg);
                  this.firstSubmit = true;
                  setTimeout(() => {
                    Toast.clear();
                  }, 1500);
                }
              }).catch(err => {
                Toast.fail(err.error_msg);
                Toast.clear();
              });

            } else {
              this.orderShow = true;
              this.isFocse = true;
              Toast.clear();
              // this.handConfirm();
            }
          }
          setTimeout(() => {

          }, 500);
        } else {
          this.orderShow = false;
          // 
          setTimeout(() => {

          }, 500);
          if (this.isOk) {
            if (this.form.number === 2 && this.form.way === 2) {
              Toast.loading({
                // mask: true, //蒙层
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "加载中..."
              });
              let params = {
                margin_ratio: parseFloat(parseFloat(this.form.numberText) /
                  100),
                order_method: 2,
                volume_mode: 1,
                orders: [{
                  account_no: this.account_no,
                  exchange_no: this.symbolGoods.exchange_code,
                  commodity_no: this.symbolGoods.commodity_no,
                  contract_no: this.symbolGoods.contract_no,
                  commodity_type: JSON.stringify(this.symbolGoods
                    .contract_type),
                  order_side: this.isBuy ? "66" : "83",
                  order_type: JSON.stringify(this.form.typeValue),
                  order_price: this.tagActive == 1 && !this.isBuy ? this
                    .symbolGoods.ask_price.toFixed(this.symbolGoods
                      .digits) : this.tagActive == 2 && !this.isBuy ?
                    this
                      .symbolGoods.bid_price.toFixed(this.symbolGoods
                      .digits) : this.form.order_price,
                  order_qty: "1",
                  addone_isvalid: this.HKT1 ? "1" : "0"
                }],
                name: this.name
              };
              // 
              if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
                params.orders.forEach(oItem => {
                  delete oItem.order_price;
                });
              }
              this.$apis.v1PrebatchorderApi(params,{
                "post": {
                  "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2
                }
              }).then(res => {
                if (res.error_code === 0) {
                  Toast.clear();
                  this.orderShow = false;
                  this.pre_code = res.code;
                  this.order_qty = res.orders[0].order_qty;
                  this.tableList = res.orders;
                  this.firstSubmit = true;
                  this.isFocse = true;
                  this.isOk = true;
                  this.handConfirm();
                } else {
                  Toast.fail(res.error_msg);
                  this.firstSubmit = false;
                  setTimeout(() => {
                    Toast.clear();
                  }, 1500);
                }
              }).catch((err) => {
                Toast.fail(err.error_msg);
                Toast.clear();
              });
              setTimeout(() => {

              }, 500);

            } else if (this.form.number === 2 && this.form.way === 1) {
              this.orderShow = false;
              Toast.loading({
                // mask: true, //蒙层
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "加载中..."
              });
              let params = {};
              let account_list = [];
              // 		this.$apis.getGroupList({
              // 			show_account: 1,
              // 			is_empty_hide: 1
              // 		}).then(res => {
              // 			if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
              // 				res.data.forEach(item => {
              // 					if (item.id === this.form.account_group) {
              // 						// 
              // 						account_list = item.account_list
              // 					}
              // 				})
              // 			} else if (res.code == 123 || res.code == 137) {
              // 				Toast.fail(res.msg)
              // 				setTimeout(() => {
              // 					this.$router.push({
              // 						name: 'h5PageLogin'
              // 					})
              // 					localStorage.removeItem("token");
              // 				}, 500)
              // 			}

              // 		})

              setTimeout(() => {

              }, 500);
              params = {
                margin_ratio: parseFloat(parseFloat(this.form
                  .numberText) / 100),
                order_method: 1,
                account_group_Id: this.form.account_group,
                orders: [],
                name: this.name,
                volume_mode: 1
              };
              this.account_list_order.forEach(item => {
                params.orders.push({
                  account_no: item,
                  exchange_no: this.symbolGoods
                    .exchange_code,
                  commodity_no: this.symbolGoods
                    .commodity_no,
                  contract_no: this.symbolGoods
                    .contract_no,
                  commodity_type: JSON.stringify(this
                    .symbolGoods.contract_type
                  ),
                  order_side: this.isBuy ? "66" : "83",
                  order_type: JSON.stringify(this
                    .form.typeValue),
                  order_price: this.tagActive == 1 && !this
                    .isBuy ? this.symbolGoods.ask_price
                      .toFixed(this.symbolGoods.digits) :
                    this.tagActive == 2 && !this.isBuy ?
                      this.symbolGoods.bid_price.toFixed(this
                        .symbolGoods.digits) : this.form
                        .order_price,
                  order_qty: "1",
                  addone_isvalid: this.HKT1 ? "1" : "0"
                });
              });

              if (params.orders.length !== 0) {
                if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
                  params.orders.forEach(oItem => {
                    delete oItem.order_price;
                  });
                }
                this.$apis.v1PrebatchorderApi(params,{
                  "post": {
                    "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2
                  }
                }).then(res => {
                  if (res.error_code === 0) {
                    Toast.clear();
                    this.orderShow = false;
                    this.pre_code = res.code;
                    this.order_qty = res.orders[0].order_qty;
                    this.tableList = res.orders;
                    this.firstSubmit = true;
                    this.isFocse = true;
                    this.handConfirm();
                  } else {
                    Toast.fail(res.error_msg);
                    this.firstSubmit = false;
                    setTimeout(() => {
                      Toast.clear();
                    }, 1500);
                  }
                }).catch(err => {
                  Toast.fail(err.error_msg);
                  Toast.clear();
                });
              }


            } else if (this.form.number === 3 && this.form.way === 1) {
              this.orderShow = false;
              Toast.loading({
                // mask: true, //蒙层
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "加载中..."
              });
              let params = {};
              let account_list = [];
              // 		this.$apis.getGroupList({
              // 			show_account: 1,
              // 			is_empty_hide: 1
              // 		}).then(res => {
              // 			if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
              // 				res.data.forEach(item => {
              // 					if (item.id === this.form.account_group) {
              // 						account_list = item.account_list
              // 						// 
              // 					}
              // 				})
              // 			} else if (res.code == 123 || res.code == 137) {
              // 				Toast.fail(res.msg)
              // 				setTimeout(() => {
              // 					this.$router.push({
              // 						name: 'h5PageLogin'
              // 					})
              // 					localStorage.removeItem("token");
              // 				}, 500)
              // 			}

              // 		})

              setTimeout(() => {

              }, 500);
              params = {
                margin_ratio: parseFloat(parseFloat(this.form
                  .numberText) / 100),
                order_method: 1,
                account_group_Id: this.form.account_group,
                orders: [],
                name: this.name,
                volume_mode: 2
              };
              this.account_list_order.forEach(item => {
                params.orders.push({
                  account_no: item,
                  exchange_no: this.symbolGoods
                    .exchange_code,
                  commodity_no: this.symbolGoods
                    .commodity_no,
                  contract_no: this.symbolGoods
                    .contract_no,
                  commodity_type: JSON.stringify(this
                    .symbolGoods.contract_type
                  ),
                  order_side: this.isBuy ? "66" : "83",
                  order_type: JSON.stringify(this
                    .form.typeValue),
                  order_price: this.tagActive == 1 && !this
                    .isBuy ? this.symbolGoods.ask_price
                      .toFixed(this.symbolGoods.digits) :
                    this.tagActive == 2 && !this.isBuy ?
                      this.symbolGoods.bid_price.toFixed(this
                        .symbolGoods.digits) : this.form
                        .order_price,
                  order_qty: this.form.numberText,
                  addone_isvalid: this.HKT1 ? "1" : "0"
                });
              });
              if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
                params.orders.forEach(oItem => {
                  delete oItem.order_price;
                });
              }
              // 
              this.$apis.v1PrebatchorderApi(params,{
                "post": {
                  "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2
                }
              }).then(res => {
                if (res.error_code === 0) {
                  Toast.clear();
                  this.orderShow = false;
                  this.pre_code = res.code;
                  this.order_qty = res.orders[0].order_qty;
                  this.tableList = res.orders;
                  this.isFocse = true;
                  this.firstSubmit = true;
                  this.handConfirm();
                } else {
                  Toast.fail(res.error_msg);
                  this.firstSubmit = false;
                  setTimeout(() => {
                    Toast.clear();
                  }, 1500);
                }
              }).catch(err => {
                Toast.fail(err.error_msg);
                setTimeout(() => {
                  Toast.clear();
                }, 1500);
              });
            } else {
              this.orderShow = false;
              Toast.clear();
              this.handConfirm();
            }
          }

        }
        if (this.firstSubmit) {
          // 
          // this.handConfirm();
        }
      } else {
        Toast.fail("网络异常,请刷新后重试");
      }
    },
    // 买入卖出公共参数
    buySellParams() {
      let price_type;  //
      if (this.form.typeValue == 49) {
        price_type = 1;
      } else {
        // 下单价格的类型 对应 api定义的类型
        // 输入 0 最新价0 排队价1  对手价2
        let keys = {
          0: 2,
          1: 4,
          2: 3,
          "-1": 0
        };
        price_type = keys[this.tagActive];
      }
      ;
      let { digits, last_price, ask_price, bid_price, date_time_stamp = 0, origin_symbol } = this.symbolGoods;
      return {
        price_type, // 0 手动输入价格 1 市价  2 最新行情价  3 对手价  4 排队价
        order_source: window.location.href, //
        quote_detail: {
          last_price: last_price ? parseFloat(parseFloat(last_price).toFixed(digits)) : 0, //最新价
          ask_price: ask_price ? parseFloat(parseFloat(ask_price).toFixed(digits)) : 0, // 买一价
          bid_price: bid_price ? parseFloat(parseFloat(bid_price).toFixed(digits)) : 0, // 卖一价
          date_time_stamp: Number(date_time_stamp) // 时间戳
        },
        origin_symbol
      };
    },
    handConfirm() {
      let params = {};
      let addParams = this.buySellParams(); // 新增的参数
      if (this.form.way === 2) {
        if (this.form.number === 1) {
          params = {
            order_method: 2,
            orders: [{
              account_no: this.account_no,
              exchange_no: this.symbolGoods.exchange_code,
              commodity_no: this.symbolGoods.commodity_no,
              contract_no: this.symbolGoods.contract_no,
              commodity_type: JSON.stringify(this.symbolGoods.contract_type),
              order_side: this.isBuy ? "66" : "83",
              order_type: JSON.stringify(this.form.typeValue),
              order_price: this.tagActive == 1 && !this.isBuy ? this.symbolGoods.ask_price
                .toFixed(this.symbolGoods.digits) : this.tagActive == 2 && !this.isBuy ?
                this.symbolGoods.bid_price.toFixed(this.symbolGoods.digits) : this.form
                  .order_price,
              order_qty: this.form.numberText,
              addone_isvalid: this.HKT1 ? "1" : "0",
              ...addParams
            }],
            name: this.name
          };

        } else {
          params = {
            pre_code: this.pre_code,
            order_method: 2,
            orders: [{
              account_no: this.account_no,
              exchange_no: this.symbolGoods.exchange_code,
              commodity_no: this.symbolGoods.commodity_no,
              contract_no: this.symbolGoods.contract_no,
              commodity_type: JSON.stringify(this.symbolGoods.contract_type),
              order_side: this.isBuy ? "66" : "83",
              order_type: JSON.stringify(this.form.typeValue),
              order_price: this.tagActive == 1 && !this.isBuy ? this.symbolGoods.ask_price
                .toFixed(this.symbolGoods.digits) : this.tagActive == 2 && !this.isBuy ?
                this.symbolGoods.bid_price.toFixed(this.symbolGoods.digits) : this.form
                  .order_price,
              order_qty: this.order_qty,
              addone_isvalid: this.HKT1 ? "1" : "0",
              ...addParams
            }],
            name: this.name
          };
        }
      } else {
        let account_list = [];
        // this.apiTimer = new Date().getTime();
        // // 
        // await this.$apis.getGroupList({
        // 	show_account: 1,
        // 	is_empty_hide: 1
        // }).then(res => {
        // 	if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
        // 		res.data.forEach(item => {
        // 			if (item.id === this.form.account_group) {
        // 				// // 
        // 				account_list = item.account_list
        // 			}
        // 		})
        // 	} else if (res.code == 123 || res.code == 137) {
        // 		Toast.fail(res.msg)
        // 		setTimeout(() => {
        // 			this.$router.push({
        // 				name: 'h5PageLogin'
        // 			})
        // 			localStorage.removeItem("token");
        // 		}, 500)
        // 	}

        // })
        if (this.form.number === 1) {
          params = {
            order_method: 1,
            account_group_Id: this.form.account_group,
            orders: [],
            name: this.name
          };
        } else {
          params = {
            pre_code: this.pre_code,
            order_method: 1,
            account_group_Id: this.form.account_group,
            orders: [],
            name: this.name
          };
        }


        // setTimeout(() => {
        // 	// // 

        // }, 200)
      }
      setTimeout(() => {

      }, 500);
      if (this.account_list_order.length !== 0) {
        this.account_list_order.forEach(item => {
          if (this.form.number === 1) {
            if (this.isBuy) {
              params.orders.push({
                account_no: item,
                exchange_no: this.symbolGoods.exchange_code,
                commodity_no: this.symbolGoods.commodity_no,
                contract_no: this.symbolGoods.contract_no,
                commodity_type: JSON.stringify(this.symbolGoods
                  .contract_type),
                order_side: "66",
                order_type: JSON.stringify(this.form.typeValue),
                order_price: this.form.order_price,
                order_qty: this.form.numberText,
                addone_isvalid: this.HKT1 ? "1" : "0",
                ...addParams
              });
            } else {
              if (this.symbolGoods.contract_type === 84) {
                this.can_close_numList.forEach(item1 => {
                  if (item1.account_no == item) {
                    if (parseFloat(this.form.numberText) > item1
                      .can_close_num) {
                      params.orders.push({
                        account_no: item,
                        exchange_no: this.symbolGoods
                          .exchange_code,
                        commodity_no: this.symbolGoods
                          .commodity_no,
                        contract_no: this.symbolGoods
                          .contract_no,
                        commodity_type: JSON.stringify(this
                          .symbolGoods.contract_type
                        ),
                        order_side: "83",
                        order_type: JSON.stringify(this
                          .form.typeValue),
                        order_price: this.tagActive == 1 &&
                        !this.isBuy ? this.symbolGoods
                          .ask_price.toFixed(this
                            .symbolGoods.digits) : this
                          .tagActive == 2 && !this
                          .isBuy ? this.symbolGoods
                          .bid_price.toFixed(this
                            .symbolGoods.digits) : this
                          .form.order_price,
                        order_qty: JSON.stringify(item1
                          .can_close_num),
                        addone_isvalid: this.HKT1 ? "1" :
                          "0",
                        ...addParams
                      });
                    } else {
                      params.orders.push({
                        account_no: item,
                        exchange_no: this.symbolGoods
                          .exchange_code,
                        commodity_no: this.symbolGoods
                          .commodity_no,
                        contract_no: this.symbolGoods
                          .contract_no,
                        commodity_type: JSON.stringify(this
                          .symbolGoods.contract_type
                        ),
                        order_side: "83",
                        order_type: JSON.stringify(this
                          .form.typeValue),
                        order_price: this.tagActive == 1 &&
                        !this.isBuy ? this.symbolGoods
                          .ask_price.toFixed(this
                            .symbolGoods.digits) : this
                          .tagActive == 2 && !this
                          .isBuy ? this.symbolGoods
                          .bid_price.toFixed(this
                            .symbolGoods.digits) : this
                          .form.order_price,
                        order_qty: this.form.numberText,
                        addone_isvalid: this.HKT1 ? "1" :
                          "0",
                        ...addParams
                      });
                    }
                  }
                });
              } else {
                params.orders.push({
                  account_no: item,
                  exchange_no: this.symbolGoods.exchange_code,
                  commodity_no: this.symbolGoods.commodity_no,
                  contract_no: this.symbolGoods.contract_no,
                  commodity_type: JSON.stringify(this.symbolGoods
                    .contract_type),
                  order_side: "83",
                  order_type: JSON.stringify(this.form.typeValue),
                  order_price: this.tagActive == 1 && !this.isBuy ? this
                    .symbolGoods.ask_price.toFixed(this.symbolGoods
                      .digits) : this.tagActive == 2 && !this.isBuy ?
                    this.symbolGoods.bid_price.toFixed(this.symbolGoods
                      .digits) : this.form.order_price,
                  order_qty: this.form.numberText,
                  addone_isvalid: this.HKT1 ? "1" : "0",
                  ...addParams
                });
              }

            }
          } else {
            params.orders.push({
              account_no: item,
              exchange_no: this.symbolGoods.exchange_code,
              commodity_no: this.symbolGoods.commodity_no,
              contract_no: this.symbolGoods.contract_no,
              commodity_type: JSON.stringify(this.symbolGoods.contract_type),
              order_side: this.isBuy ? "66" : "83",
              order_type: JSON.stringify(this.form.typeValue),
              order_price: this.tagActive == 1 && !this.isBuy ? this
                  .symbolGoods.ask_price.toFixed(this.symbolGoods.digits) :
                this.tagActive == 2 && !this.isBuy ? this.symbolGoods
                  .bid_price.toFixed(this.symbolGoods.digits) : this.form
                  .order_price,
              order_qty: this.order_qty,
              addone_isvalid: this.HKT1 ? "1" : "0",
              ...addParams
            });
          }

        });
      }
      if (this.isOk) {
        Toast.loading({
          // mask: true, //蒙层
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: "spinner",
          message: "加载中..."
        });
        const device_no = sessionStorage.getItem("device_no");
        const sysyem = sessionStorage.getItem("sysyem");
        const version = sessionStorage.getItem("version");
        const device = sessionStorage.getItem("device");
        const clientTypes = sessionStorage.getItem("clientTypes");
        const network = sessionStorage.getItem("network");
        const key = sessionStorage.getItem("key");

        // 
        params.reverse_order = this.isReverse ? 1 : 0;
        // 不要价格的单子
        if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
          params.orders.forEach(oItem => {
            delete oItem.order_price;
          });
        }
        this.$apis.queryBatchorder(params, {
          "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2,
        }).then(res => {
          let errCode = [];
          if (res.data) {
            errCode = res.data.filter(item => item.error_code !== 0);
          }

          if (res.error_code === 0 && errCode.length === 0) {
            Toast.success("订单已提交，请关注订单状态");
            setTimeout(() => {
              Toast.clear();
            }, 1500);
            // this.tagActive = 0
            // if(this.symbolGoods.last_price){
            // 	this.form.order_price = this.symbolGoods.last_price.toFixed(this.symbolGoods.digits)
            // }else{
            // }
            // this.amount = (parseFloat(this.symbolGoods.last_price) * parseFloat(this.form.numberText)).toFixed(2)
            this.handNumberChange();
            this.orderShow = false;
            this.isFocse = false;
            this.notifyNewOrderToChild();
          } else if (res.error_code === 0 && errCode.length !== 0) {
            Toast.clear();
            // // 
            Dialog.alert({
              title: `${errCode[0].account_no}(${errCode[0].account_name})`,
              message: `提交失败,${errCode[0].error_msg},请重试`,
              closeOnClickOverlay: true,
              confirmButtonText: "知道了"
            }).then(() => {
              this.delayReplayWsSend();

              this.orderShow = false;
            });
            // this.tagActive = 0
            // if(this.symbolGoods.last_price){
            // 	this.form.order_price = this.symbolGoods.last_price.toFixed(this.symbolGoods.digits)
            // }else{
            // }
            this.handNumberChange();
            // if(this.form.number ==)
            // this.amount = (parseFloat(this.symbolGoods.last_price) * parseFloat(this.form.numberText)).toFixed(2)
            this.orderShow = false;
            this.isFocse = false;
          } else if (res.error_code !== 0 && !res.data) {
            if (res.code && res.code === 100019) {
              Toast.fail(res.msg);
              this.$router.push({
                name: "h5PageLogin"
              });
              localStorage.removeItem("token");
            } else {
              // // 
              Toast.clear();
              Dialog.alert({
                title: `提示`,
                message: `提交失败,${res.error_msg},请重试`,
                closeOnClickOverlay: true,
                confirmButtonText: "知道了"
              }).then(() => {
                this.delayReplayWsSend();
                this.orderShow = false;
              });
              // this.tagActive = 0
              // if(this.symbolGoods.last_price){
              // 	this.form.order_price = this.symbolGoods.last_price.toFixed(this.symbolGoods.digits)
              // }else{
              // }
              // this.amount = (parseFloat(this.symbolGoods.last_price) * parseFloat(this.form.numberText)).toFixed(2)
              this.handNumberChange();
              this.orderShow = false;
              this.isFocse = false;
            }

          } else {
            Toast.clear();
            // this.tagActive = 0
            // if(this.symbolGoods.last_price){
            // 	this.form.order_price = this.symbolGoods.last_price.toFixed(this.symbolGoods.digits)
            // }else{
            // }
            // this.amount = (parseFloat(this.symbolGoods.last_price) * parseFloat(this.form.numberText)).toFixed(2)
            this.handNumberChange();
            this.orderShow = false;
            this.isFocse = false;
            Toast.fail(`操作失败`);
          }
        }).catch(err => {});

      }


      let par = {
        create_order: this.create_order ? 0 : 1
      };
      this.$apis.setTransactionSetting(par).then(res => {
        let obj = this.$localstorage.get("openObj");
        obj.create_order = this.create_order ? 0 : 1;
        this.$localstorage.set("openObj", obj);
      });


    },

    delayReplayWsSend(){
      let struct = {
        MsgType: "SubTicks",
        MsgBody: {
          symbol: this.symbolGoods.symbol
        }
      };
      // sendSock(struct);
      this.$socket.sendMsg(struct);
    },

    handSell() {
      let numPattern = /^-?\d*\.?\d+$/;

      let numSl = /^[0-9]\d*$/;

      if (this.form.order_price && !numPattern.test(this.form.order_price)) {
        return Toast.fail("价格只可以输入数字或小数");
      }

      if (this.form.number === 1 || this.form.number === 3) {
        if (parseFloat(this.form.numberText) % parseFloat(this.symbolGoods.lot_min) !== 0) {
          return Toast.fail("请输入正确的数量");
        }
      }

      if (!this.form.numberText) {
        return Toast.fail("请输入正确的数量");
      }

      if (this.symbolGoods.contract_type === 84 && this.form.number === 2) {
        return Toast.fail("不支持该下单模式");
      }


      let price = "";
      let exchangeCode = [];
      let m = "";
      Toast.loading({
        // mask: true, //蒙层
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中..."
      });
      this.$apis.quoteQueryChangeunitApi().then(res => {
        res.infos.forEach(item => {
          exchangeCode.push(item.exchangeCode);
        });
        if (exchangeCode.findIndex(item => item === this.symbolGoods.exchange_code) > -1) {
          res.infos.forEach(item => {
            exchangeCode.push(item.exchangeCode);
            if (item.exchangeCode === this.symbolGoods.exchange_code && item.typ ===
              this.symbolGoods.contract_type) {
              item.rules.forEach(item1 => {
                if ((parseFloat(this.form.order_price) > item1.begin ||
                  parseFloat(this.form.order_price) == item1.begin) && (
                  parseFloat(this.form.order_price) < item1.end ||
                  parseFloat(this.form.order_price) == item1.end)) {
                  price = parseFloat(this.form.order_price) / (parseFloat(
                    item1.changeUnit));
                  m = parseFloat(item1.changeUnit);
                }
              });
              if (parseFloat(this.form.order_price) > item.rules[item.rules.length - 1]
                .end) {
                price = parseFloat(this.form.order_price) / (parseFloat(
                  item.rules[item.rules.length - 1].changeUnit));
              }
            }
          });
        } else {
          price = parseFloat(this.form.order_price) / (parseFloat(this.symbolGoods
            .commodity_tick_size));
          m = parseFloat(this.symbolGoods.commodity_tick_size);
        }

        // 
        if ((parseFloat(this.form.order_price) % m).toFixed(5) != 0) {
          if (price && (parseFloat(this.form.order_price) % m).toFixed(5) != m) {
            this.isOk = false;
            return Toast.fail("请输入正确的价格");
          } else {
            this.isOk = true;
            // 只有正确后才能调取
            this.handSellOk();
          }
        } else {
          this.isOk = true;
          // 只有正确后才能调取
          this.handSellOk();
        }

      });
      this.isBuy = false;

      if (this.form.way === 1) {
        this.accountCurrencyColumns.forEach(item => {
          if (item.value === this.form.account_group) {
            this.account_no = item.text;
            this.name = item.text;
          }
        });
      } else {
        this.accountCurrencyColumns.forEach(item => {
          if (item.value === this.form.account_group) {
            this.account_no = item.name;
            this.name = item.resultName;
          }
        });
      }


    },
    // 是否可卖出,封装,目前还有优化空间
    handSellOk() {
      let obj = this.$localstorage.get("openObj");
      if (obj) {
        this.create_order = obj.create_order == 0 ? true : false;
        if (obj.create_order === 1) {
          Toast.clear();
          if (this.form.way === 2 && this.form.number === 1 && parseFloat(this.form
            .numberText) > parseFloat(this.can_close_num) && this.symbolGoods
            .contract_type === 84) {
            return Toast.fail("已超过可卖数量");
          } else if (this.form.number === 2) {
            Toast.clear();
            // this.orderShow = true
            this.isFocse = true;
          } else if (this.form.way === 2 && this.form.number === 1 && (parseFloat(
              this.form.numberText) < parseFloat(this.can_close_num) ||
            parseFloat(this.form.numberText) == parseFloat(this.can_close_num)
          ) && this.symbolGoods.contract_type === 84) {
            Toast.clear();
            // this.orderShow = true
            this.isFocse = true;
          } else if (this.form.way === 1) {
            Toast.clear();
            // this.orderShow = true
            this.isFocse = true;
          } else if (this.form.way === 2 && this.form.number === 1 && this
            .symbolGoods.contract_type !== 84) {
            Toast.clear();
            // this.orderShow = true
            this.isFocse = true;
          }
          if (this.isOk) {
            if (this.form.number === 2 && this.form.way === 2) {
              Toast.loading({
                // mask: true, //蒙层
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "加载中..."
              });
              let params = {
                margin_ratio: parseFloat(parseFloat(this.form.numberText) /
                  100),
                order_method: 2,
                volume_mode: 1,
                orders: [{
                  account_no: this.account_no,
                  exchange_no: this.symbolGoods.exchange_code,
                  commodity_no: this.symbolGoods.commodity_no,
                  contract_no: this.symbolGoods.contract_no,
                  commodity_type: JSON.stringify(this.symbolGoods
                    .contract_type),
                  order_side: this.isBuy ? "66" : "83",
                  order_type: JSON.stringify(this.form.typeValue),
                  order_price: this.tagActive == 1 && !this.isBuy ? this
                    .symbolGoods.ask_price.toFixed(this.symbolGoods
                      .digits) : this.tagActive == 2 && !this.isBuy ?
                    this
                      .symbolGoods.bid_price.toFixed(this.symbolGoods
                      .digits) : this.form.order_price,
                  order_qty: "1",
                  addone_isvalid: this.HKT1 ? "1" : "0"
                }],
                name: this.name
              };
              if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
                params.orders.forEach(oItem => {
                  delete oItem.order_price;
                });
              }
              this.$apis.v1PrebatchorderApi(params, {
                "post": {
                  "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2
                }
              }).then(res => {
                if (res.error_code === 0) {
                  Toast.clear();
                  this.orderShow = true;
                  this.pre_code = res.code;
                  this.order_qty = res.orders[0].order_qty;
                  this.tableList = res.orders;
                  this.isFocse = true;
                  this.firstSubmit = true;
                } else {
                  Toast.fail(res.error_msg);
                  this.firstSubmit = false;
                  setTimeout(() => {
                    Toast.clear();
                  }, 1500);
                }
              }).catch((err) => {
                Toast.fail(err.error_msg);
                Toast.clear();
              });

            } else if (this.form.number === 2 && this.form.way === 1) {
              this.orderShow = false;
              Toast.loading({
                // mask: true, //蒙层
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "加载中..."
              });
              let params = {};
              let account_list = [];
              params = {
                margin_ratio: parseFloat(parseFloat(this.form
                  .numberText) / 100),
                order_method: 1,
                account_group_Id: this.form.account_group,
                orders: [],
                name: this.name,
                volume_mode: 1
              };
              this.account_list_order.forEach(item => {
                params.orders.push({
                  account_no: item,
                  exchange_no: this.symbolGoods
                    .exchange_code,
                  commodity_no: this.symbolGoods
                    .commodity_no,
                  contract_no: this.symbolGoods
                    .contract_no,
                  commodity_type: JSON.stringify(this
                    .symbolGoods.contract_type
                  ),
                  order_side: this.isBuy ? "66" : "83",
                  order_type: JSON.stringify(this
                    .form.typeValue),
                  order_price: this.tagActive == 1 && !this
                    .isBuy ? this.symbolGoods.ask_price
                      .toFixed(this.symbolGoods.digits) :
                    this.tagActive == 2 && !this.isBuy ?
                      this.symbolGoods.bid_price.toFixed(this
                        .symbolGoods.digits) : this.form
                        .order_price,
                  order_qty: "1",
                  addone_isvalid: this.HKT1 ? "1" : "0"
                });
              });
              // 
              if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
                params.orders.forEach(oItem => {
                  delete oItem.order_price;
                });
              }
              this.$apis.v1PrebatchorderApi(params, {
                "post": {
                  "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2
                }
              }).then(res => {
                if (res.error_code === 0) {
                  Toast.clear();
                  this.orderShow = true;
                  this.pre_code = res.code;
                  this.order_qty = res.orders[0].order_qty;
                  this.tableList = res.orders;
                  this.isFocse = true;
                  this.firstSubmit = true;
                } else {
                  Toast.fail(res.error_msg);
                  this.firstSubmit = false;
                  setTimeout(() => {
                    Toast.clear();
                  }, 1500);
                }
              }).catch(err => {
                Toast.fail(err.error_msg);
                Toast.clear();
              });

              setTimeout(() => {

              }, 500);


            } else if (this.form.number === 3 && this.form.way === 1) {
              this.orderShow = false;
              Toast.loading({
                // mask: true, //蒙层
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "加载中..."
              });
              let params = {};
              let account_list = [];
              params = {
                margin_ratio: parseFloat(parseFloat(this.form
                  .numberText) / 100),
                order_method: 1,
                account_group_Id: this.form.account_group,
                orders: [],
                name: this.name,
                volume_mode: 2
              };
              this.account_list_order.forEach(item => {
                params.orders.push({
                  account_no: item,
                  exchange_no: this.symbolGoods
                    .exchange_code,
                  commodity_no: this.symbolGoods
                    .commodity_no,
                  contract_no: this.symbolGoods
                    .contract_no,
                  commodity_type: JSON.stringify(this
                    .symbolGoods.contract_type
                  ),
                  order_side: this.isBuy ? "66" : "83",
                  order_type: JSON.stringify(this
                    .form.typeValue),
                  order_price: this.tagActive == 1 && !this
                    .isBuy ? this.symbolGoods.ask_price
                      .toFixed(this.symbolGoods.digits) :
                    this.tagActive == 2 && !this.isBuy ?
                      this.symbolGoods.bid_price.toFixed(this
                        .symbolGoods.digits) : this.form
                        .order_price,
                  order_qty: this.form.numberText,
                  addone_isvalid: this.HKT1 ? "1" : "0"
                });
              });
              // 
              if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
                params.orders.forEach(oItem => {
                  delete oItem.order_price;
                });
              }
              this.$apis.v1PrebatchorderApi(params, {
                "post":{
                  "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2
                }
              }).then(res => {
                if (res.error_code === 0) {
                  Toast.clear();
                  this.orderShow = true;
                  this.pre_code = res.code;
                  this.order_qty = res.orders[0].order_qty;
                  this.tableList = res.orders;
                  this.isFocse = true;
                  this.firstSubmit = true;
                } else {
                  Toast.fail(res.error_msg);
                  this.firstSubmit = false;
                  setTimeout(() => {
                    Toast.clear();
                  }, 1500);
                }
              }).catch(err => {
                Toast.fail(err.error_msg);
                Toast.clear();
              });
              setTimeout(() => {

              }, 500);


            } else {
              this.orderShow = true;
              this.isFocse = true;
              Toast.clear();
              // this.handConfirm();
            }
          }
          setTimeout(() => {

          }, 500);
        } else {
          this.orderShow = false;
          Toast.clear();
          if (this.form.way === 2 && this.form.number === 1 && parseFloat(this.form.numberText) >
            parseFloat(this.can_close_num) && this.symbolGoods.contract_type === 84) {
            return Toast.fail("已超过可卖数量");
          }
          if (this.isOk) {
            if (this.form.number === 2 && this.form.way === 2) {
              Toast.loading({
                // mask: true, //蒙层
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "加载中..."
              });
              let params = {
                margin_ratio: parseFloat(parseFloat(this.form.numberText) /
                  100),
                order_method: 2,
                volume_mode: 1,
                orders: [{
                  account_no: this.account_no,
                  exchange_no: this.symbolGoods.exchange_code,
                  commodity_no: this.symbolGoods.commodity_no,
                  contract_no: this.symbolGoods.contract_no,
                  commodity_type: JSON.stringify(this.symbolGoods
                    .contract_type),
                  order_side: this.isBuy ? "66" : "83",
                  order_type: JSON.stringify(this.form.typeValue),
                  order_price: this.tagActive == 1 && !this.isBuy ? this
                    .symbolGoods.ask_price.toFixed(this.symbolGoods
                      .digits) : this.tagActive == 2 && !this.isBuy ?
                    this
                      .symbolGoods.bid_price.toFixed(this.symbolGoods
                      .digits) : this.form.order_price,
                  order_qty: "1",
                  addone_isvalid: this.HKT1 ? "1" : "0"
                }],
                name: this.name
              };
              // 
              if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
                params.orders.forEach(oItem => {
                  delete oItem.order_price;
                });
              }
              this.$apis.v1PrebatchorderApi(params, {
                "post": {
                  "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2
                }
              }).then(res => {
                if (res.error_code === 0) {
                  Toast.clear();
                  this.orderShow = false;
                  this.pre_code = res.code;
                  this.order_qty = res.orders[0].order_qty;
                  this.tableList = res.orders;
                  this.isFocse = true;
                  this.firstSubmit = true;
                  this.handConfirm();
                } else {
                  Toast.fail(res.error_msg);
                  this.firstSubmit = false;
                  setTimeout(() => {
                    Toast.clear();
                  }, 1500);
                }
              }).catch((err) => {
                Toast.fail(err.error_msg);
                Toast.clear();
              });

              setTimeout(() => {

              }, 500);

            } else if (this.form.number === 2 && this.form.way === 1) {
              this.orderShow = false;
              Toast.loading({
                // mask: true, //蒙层
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "加载中..."
              });
              let params = {};
              let account_list = [];
              params = {
                margin_ratio: parseFloat(parseFloat(this.form
                  .numberText) / 100),
                order_method: 1,
                account_group_Id: this.form.account_group,
                orders: [],
                name: this.name,
                volume_mode: 1
              };
              this.account_list_order.forEach(item => {
                params.orders.push({
                  account_no: item,
                  exchange_no: this.symbolGoods
                    .exchange_code,
                  commodity_no: this.symbolGoods
                    .commodity_no,
                  contract_no: this.symbolGoods
                    .contract_no,
                  commodity_type: JSON.stringify(this
                    .symbolGoods.contract_type
                  ),
                  order_side: this.isBuy ? "66" : "83",
                  order_type: JSON.stringify(this
                    .form.typeValue),
                  order_price: this.tagActive == 1 && !this
                    .isBuy ? this.symbolGoods.ask_price
                      .toFixed(this.symbolGoods.digits) :
                    this.tagActive == 2 && !this.isBuy ?
                      this.symbolGoods.bid_price.toFixed(this
                        .symbolGoods.digits) : this.form
                        .order_price,
                  order_qty: "1",
                  addone_isvalid: this.HKT1 ? "1" : "0"
                });
              });
              // 
              if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
                params.orders.forEach(oItem => {
                  delete oItem.order_price;
                });
              }
              this.$apis.v1PrebatchorderApi(params, {
                "post": {
                  "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2
                }
              }).then(res => {
                if (res.error_code === 0) {
                  Toast.clear();
                  this.orderShow = false;
                  this.pre_code = res.code;
                  this.order_qty = res.orders[0].order_qty;
                  this.tableList = res.orders;
                  this.isFocse = true;
                  this.firstSubmit = true;
                  this.handConfirm();
                } else {
                  Toast.fail(res.error_msg);
                  this.firstSubmit = false;
                  setTimeout(() => {
                    Toast.clear();
                  }, 1500);
                }
              }).catch(err => {
                Toast.fail(err.error_msg);
                setTimeout(() => {
                  Toast.clear();
                }, 1500);
              });

              setTimeout(() => {

              }, 500);


            } else if (this.form.number === 3 && this.form.way === 1) {
              this.orderShow = false;
              Toast.loading({
                // mask: true, //蒙层
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "加载中..."
              });
              let params = {};
              let account_list = [];
              params = {
                margin_ratio: parseFloat(parseFloat(this.form
                  .numberText) / 100),
                order_method: 1,
                account_group_Id: this.form.account_group,
                orders: [],
                name: this.name,
                volume_mode: 2
              };
              this.account_list_order.forEach(item => {
                params.orders.push({
                  account_no: item,
                  exchange_no: this.symbolGoods
                    .exchange_code,
                  commodity_no: this.symbolGoods
                    .commodity_no,
                  contract_no: this.symbolGoods
                    .contract_no,
                  commodity_type: JSON.stringify(this
                    .symbolGoods.contract_type
                  ),
                  order_side: this.isBuy ? "66" : "83",
                  order_type: JSON.stringify(this
                    .form.typeValue),
                  order_price: this.tagActive == 1 && !this
                    .isBuy ? this.symbolGoods.ask_price
                      .toFixed(this.symbolGoods.digits) :
                    this.tagActive == 2 && !this.isBuy ?
                      this.symbolGoods.bid_price.toFixed(this
                        .symbolGoods.digits) : this.form
                        .order_price,
                  order_qty: this.form.numberText,
                  addone_isvalid: this.HKT1 ? "1" : "0"
                });
              });
              // 
              if (this.noPriceType.includes(JSON.stringify(this.form.typeValue))) {
                params.orders.forEach(oItem => {
                  delete oItem.order_price;
                });
              }
              this.$apis.v1PrebatchorderApi(params, {
                "post": {
                  "X-channel-id": this.symbolGoods.contract_type === 70 ? 1 : 2
                }
              }).then(res => {
                if (res.error_code === 0) {
                  Toast.clear();
                  this.orderShow = false;
                  this.pre_code = res.code;
                  this.order_qty = res.orders[0].order_qty;
                  this.tableList = res.orders;
                  this.isFocse = true;
                  this.firstSubmit = true;
                  this.handConfirm();
                } else {
                  Toast.fail(res.error_msg);
                  this.firstSubmit = false;
                  setTimeout(() => {
                    Toast.clear();
                  }, 1500);
                }
              }).catch(err => {
                Toast.fail(err.error_msg);
                Toast.clear();
              });


            } else {
              this.orderShow = false;
              Toast.clear();
              this.handConfirm();
            }
          }
          setTimeout(() => {

          }, 500);
          setTimeout(() => {
            // Toast.clear();

          }, 1200);
          // if (this.firstSubmit) {
          // 	this.handConfirm();
          // }
        }
      } else {
        Toast.fail("网络异常,请刷新后重试");
      }
    },
    notifyNewOrderToChild() {
      this.$refs["account-details"].notifyNewOrder();
    },
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        // 页面可见时执行的操作
        this.refreshAccount();
      }
    },
    visibilityListenerFn() {
      this.handleVisibilityChange();
    },
    startPageSwitchListener() {
      document.addEventListener("visibilitychange", this.visibilityListenerFn);
    },
    stopPageSwitchListener() {
      document.removeEventListener("visibilitychange", this.visibilityListenerFn);
    },
    refreshAccount() {
      // way 1 按组、 way 2 按账户
      if (this.form.way === 1) {
        this.$apis.getGroupList({
          show_account: 1,
          is_empty_hide: 1
        }).then(res => {
          this.accountCurrencyColumns = [];
          if(res.data && res.data.length > 0){
            res.data.forEach(item => {
              this.accountCurrencyColumns.push({
                text: item.group_name,
                value: item.id,
                id: item.id,
                list: item.account_list
              });
            });
          }
        }).catch(err => {});
      } else if (this.form.way === 2) {
        this.$apis.h5PageGetAccount().then(res => {
          if (res.code === 0 && JSON.stringify(res.data) !== "{}") {
            this.accountCurrencyColumns = [];
            if(res.data && res.data.length > 0){
              res.data.forEach(item => {
                this.accountCurrencyColumns.push({
                  text: `${item.futures_login_id}(${item.futures_name})`,
                  value: item.id,
                  id: item.group_id,
                  name: item.futures_login_id,
                  resultName: item.futures_name
                });
              });
            }
          }
        }).catch(err => {});
      }
      // 刷新快照接口

      // 
      if(this.symbolGoods && this.symbolGoods.symbol){
        this.$apis.future_ticksnapshot({
          symbol: this.symbolGoods.symbol
        }).then(res => {
          if (res.future_ticks.length !== 0) {
            this.symbolGoods.last_price = res.future_ticks[0].last_price;
            this.symbolGoods.change_value = res.future_ticks[0].change_value;
            this.symbolGoods.change_rate = res.future_ticks[0].change_rate;
            this.symbolGoods.date_time_stamp = res.future_ticks[0].date_time_stamp;
            this.form.order_price = res.future_ticks[0].last_price.toFixed(this.symbolGoods.digits);
            if (res.future_ticks[0].bid_price.length !== 0) {
              this.symbolGoods.bid_price = res.future_ticks[0].bid_price[0];
            }
            if (res.future_ticks[0].ask_price.length !== 0) {
              this.symbolGoods.ask_price = res.future_ticks[0].ask_price[0];
            }

            const msg = res.future_ticks[0];
            if ((msg.bid_price && msg.bid_price.length !== 0) && (msg.ask_price && msg.ask_price.length !== 0)) {
              this.tagList = [{
                id: 0,
                name: "最新价"
              }, {
                id: 1,
                name: "排队价"
              }, {
                id: 2,
                name: "对手价"
              }];
            } else if ((!msg.bid_price || msg.bid_price.length === 0) && (msg.ask_price && msg.ask_price.length !== 0)) {
              this.tagList = [{
                id: 0,
                name: "最新价"
              }, {
                id: 2,
                name: "对手价"
              }];
            } else if ((msg.bid_price && msg.bid_price.length !== 0) && (!msg.ask_price || msg.ask_price.length === 0)) {
              this.tagList = [{
                id: 0,
                name: "最新价"
              }, {
                id: 1,
                name: "排队价"
              }];
            } else if ((!msg.bid_price || msg.bid_price.length === 0) && (!msg.ask_price || msg.ask_price.length === 0)) {
              this.tagList = [{
                id: 0,
                name: "最新价"
              }];
            }


            this.symbolGoods.pre_closing_price = res.future_ticks[0].pre_closing_price;
            this.tagShow = true;
            this.delPrPng = require("@/assets/images/h5Page/del.png");
          } else {
            this.symbolGoods.last_price = 0;
            this.symbolGoods.change_value = 0;
            this.symbolGoods.change_rate = 0;
            this.form.order_price = "";
            this.symbolGoods.bid_price = "";
            this.symbolGoods.ask_price = "";
            this.symbolGoods.pre_closing_price = "";
            this.symbolGoods.date_time_stamp = "";
            // this.tagActive = -1
            this.tagShow = false;
          }
        });
      }
    }
  },
  destroyed() {
    bus.$off("onmessage");
    this.$socket.stop();
    this.isReverse = false;
  }
};
</script>

<style lang="less" scoped>
.tick-time{
  color: #d7cbcb;
  font-size: 24px;
  flex: 1;
  text-align: right;
}
.is-reverse-tip{
  background: #372321;
  color: #FF9275;
  height: 50px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  font-size: 24px;
  position: fixed;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  box-sizing: border-box;
  z-index: 2006;
  .text{
    margin-left: 10px;
  }
}
/deep/ .van-cell-group--inset{
  margin: 0;
}
.mick-wrap{

}
.mick-box{
  position: relative;
  margin-bottom: 22px;
  &.is-reverse{
    padding-top: 50px;
    &.error-network{
      padding-top: 0;
    }
  }
  /deep/ .van-cell{
    color: #646566;
  }
}
.form-box {
  padding: 0 20px;
  background: #fff;

  .form-hr {
    background-color: #EEEEEE;
    margin-left: 5%;
    margin-right: 5%;
    width: 90%;
  }

  /deep/ .van-hairline--bottom {
    .van-cell {
      height: 100px;
      padding: 0;

      &:last-child {
        &::after {
          display: none;
        }
      }
    }

    &:last-child {
      &::after {
        display: none;
      }
    }
  }

  /deep/ .van-cell {
    &::after {
      // display: none;
    }
  }
}

/deep/ .van-dialog {
  border-radius: 8px;

  img {
    width: 14px;
    height: auto;
    margin-left: 24px;
  }

  .van-button--primary {
    box-shadow: none;
  }

  .dialog-btn {
    padding-top: 64px;

    &.dialog-btn-mk {
      padding-top: 36px;
    }
  }
}

/deep/ .van-field__label {
  width: 120px;
}

.second-box {
  margin-top: 22px;
  padding: 0 20px;
  background: #fff;
  border-bottom: 2px solid #F5F6F7;

  &.no-bor {
    border: none;

    .van-cell {
      border: none;
    }
  }

  // padding-bottom: 20px;
  img {
    width: 14px;
    height: auto;
    margin-left: 24px;
  }

  .symbol-div {
    position: relative;
    // border-top:1px solid #ebedf0;
    padding-bottom: 20px;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: -50%;
      width: 200%;
      height: 1px;
      background: #eee;
      transform: scale(0.5);
    }
  }

  .cell-type {
    /deep/ .van-cell__title {
      width: 120px;
      flex: none;
      margin-right: 24px;
    }

    /deep/ .van-cell__value {
      text-align: left;
      color: #444;
    }
  }

  /deep/ .van-field__right-icon {
    align-self: inherit;
    padding-left: 0;
    padding-bottom: 0;
    padding-top: 8px;

    .van-icon {
      font-size: 40px;
    }
  }

  /deep/ .van-cell {
    height: 100px;
    padding: 0;

    .van-cell__value,
    .van-field__label {
      line-height: 100px;
    }
  }

  /deep/ .van-hairline--top-bottom {
    &::after {
      display: none;
    }
  }

  .overlay-top {
    margin-top: 520px;
    z-index: 100;
    &.showNetworkTips.is-reverse{
      margin-top: 640px;
    }
    &.showNetworkTips,&.is-reverse {
      margin-top: 590px;
    }
  }

  .tag-box {
    width: 100%;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    background-color: #fff;

    .tag {
      width: 100px;
      // height: 36px;
      text-align: center;
      // line-height: 36px;
      font-size: 22px;
      background-color: #F0F0F0;
      margin-right: 12px;
      margin-top: 16px;
      border-radius: 4px;
      padding: 2px 14px;
      padding-top: 6px;
    }

    .tagActive {
      background-color: #1C0955;
      color: #fff;
    }
  }

  .form-end-box {
    display: flex;
    border-bottom: 1px solid #F1F3F4;

    .select-box {
      flex: 1;

      /deep/ .van-cell::after {
        display: none;
      }

      &:last-child {
        /deep/ .van-cell {
          padding-left: 60px;
        }
      }

    }

    .input-line {
      position: relative;
      display: flex;

      // &::after{
      // 	position: absolute;
      // 	box-sizing: border-box;
      // 	content: ' ';
      // 	pointer-events: none;
      // 	top: -50%;
      // 	right: -50%;
      // 	bottom: -50%;
      // 	left: -50%;
      // 	border-bottom: 1px solid #ebedf0;
      // 	-webkit-transform: scale(.5);
      // 	transform: scale(.5);
      // }
      .van-cell::after {
        display: none;
      }

      .delPngBox {
        border: none;
      }
    }

    .van-cell {
      // border: none !important;
    }
  }

  .noData {
    background-color: #FAFAFC;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .icon {
      width: 126px;
      height: 120px;
      margin-bottom: 30px;
    }

    .text {
      color: #888888;
      font-size: 26px;
    }
  }

  .symbolList-box {
    max-height: 300px;
    overflow-y: auto;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background-color: #FAFAFC;
    .is_main{
      border: #4994df solid 1px;
      font-size: 20px;
      color: #4994df;
      padding: 5px;
      line-height: 20px;
      margin-left: 10px;
      border-radius: 5px;
    }
    /deep/ .van-cell {
      padding: 0 20px;
      background-color: inherit;
    }

    /deep/ .van-cell__value {
      color: #444444;
    }
  }

  .symbol-detail {
    background-color: #fff;
    // min-height: 1.2rem;
    // padding: 0px 0.26667rem;
    // line-height: 1.2rem;
    line-height: 60px;
    display: flex;
    padding: 0;
  }

  .lowDetail {
    background: linear-gradient(to right, #e5f6eb, rgba(229, 246, 235, 0.30));
    color: #02AA39;
    // width: 100%;
    flex: 1;
    padding: 0px 0.26667rem;
    margin: 0 -20px;
  }

  .upDetail {
    background: linear-gradient(to right, rgba(255, 234, 232, 0.30), rgba(255, 234, 232, 0.50));
    color: #E83324;
    // width: 100%;
    flex: 1;
    padding: 0px 0.26667rem;
    margin: 0 -20px;
  }

  .pinDetail {
    background: #fff;
    color: #888888;
    flex: 1;
    padding: 0px 0.26667rem;
    margin: 0 -20px;
  }

  .pinColor {
    color: #888888;
  }

  .upColor {
    color: #E83324;
  }

  .downColor {
    color: #02AA39;
  }


  .hkList {
    background-color: #fff;
    min-height: 1.2rem;
    // padding: 0px 0.26667rem;
    line-height: 1.2rem;
    display: flex;

    // border-bottom: 1px solid #F5F6F7;
    .hk-div {
      justify-content: flex-end;
      align-items: center;
      display: flex;
      width: 100%;

      /deep/ .van-checkbox__icon {
        font-size: 24px;
      }

      input,
      /deep/ .van-checkbox__icon .van-icon {
        height: 24px;
        width: 24px;
        margin-right: 14px;
      }

      span {
        font-size: 24px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #444444;
        line-height: 34px;
      }
    }
  }
}


.bottom-btn {
  display: flex;
  width: 100%;
  padding: 0 20px;
  background: #fff;
  justify-content: space-between;
  box-sizing: border-box;
  //height: calc(100vh - 788px);
  overflow: hidden;

  .btn-box {
    // flex: 1;
    margin: 20px 0;
    width: calc(50% - 10px);

    // padding-left: 20px;
    // padding-right: 20px;
    &.def {

      .sell-btn,
      .buy-btn {
        height: 80px;
      }
    }

    .buy-btn {
      height: 110px;
      background-color: #EB3323;
      color: #fff;
      border-radius: 8px;
      font-weight: 500;
      font-family: inherit;
      border: 0;
    }

    .sell-btn {
      height: 110px;
      background-color: #02AA39;
      color: #fff;
      border-radius: 8px;
      font-weight: 500;
      font-family: inherit;
      border: 0;
    }
  }
}

.cell-box {
  height: 96px;
  text-align: center;
  line-height: 96px;
  border-bottom: 1px solid #EEEEEE;
}

.cell-box1 {
  height: 96px;
  text-align: center;
  line-height: 96px;
}

.cell-box-dia {
  display: flex;
  margin: 0.3rem;
  align-items: center;

  /deep/ .van-button--primary {
    width: 100%;
    height: 80px;
  }

  .cell-lable {
    flex: 1;
    text-align: left;
    font-size: 28px;
    color: #888888;
    // height: 56px;
  }

  .cell-value {
    flex: 1;
    text-align: right;
    font-size: 28px;
    color: #1C0955;

    // height: 56px;
    .table-option {
      display: flex;
      position: absolute;
      box-shadow: 0px 0px 20px 0px rgba(136, 136, 136, 0.40);
      padding: 16px;
      background: #fff;
      font-size: 24px;
      border-radius: 8px;
      right: 30px;
      margin-top: 20px;
      z-index: 100;

      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        border-top: 20px solid transparent;
        border-right: 15px solid transparent;
        border-left: 15px solid transparent;
        border-bottom: 15px solid #fff;
        top: -35px;
        right: 15%;
      }

      &-item {
        text-align: left;
        padding: 0 20px;
        margin-bottom: 14px;
      }
    }

    .select-option {
      position: absolute;
      box-shadow: 0px 0px 20px 0px rgba(136, 136, 136, 0.40);
      // padding: 16px;
      background: #fff;
      font-size: 24px;
      border-radius: 8px;
      right: 30px;
      margin-top: 20px;

      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        border-top: 20px solid transparent;
        border-right: 15px solid transparent;
        border-left: 15px solid transparent;
        border-bottom: 15px solid #fff;
        top: -35px;
        right: 15%;
      }

      &-item {
        font-size: 26px;
        color: #444444;
        // height: 20px;line-height: 20px;
        text-align: center;
        padding: 12px 15px;
        position: relative;

        &::before {
          content: "";
          display: block;
          position: absolute;
          left: 0%;
          bottom: 0%;
          width: 200%;
          // height: 200%;
          border-bottom: 1px solid #eeeeee;
          border-top: none;
          border-right: none;
          transform-origin: 0 0;
          transform: scale(0.5);
        }

        &:last-child {
          &::before {
            display: none;
          }
        }
      }
    }
  }

  .label-name {
    color: #444444;
    font-size: 28px;
  }

  .span-name {
    color: #888888;
    font-size: 24px;
  }
}

/deep/ .van-popover__action {
  height: 30px;
  line-height: 30px;
  text-align: center;
}

/deep/ .van-popup {
  box-shadow: 0px 0px 10px 0px rgb(136 136 136 / 40%);
  padding: 10px;
}

/deep/ .van-popup--bottom {
  max-width: 1000PX;
  left: 50%;
  transform: translateX(-50%);
}

/deep/ .van-cell__value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.delPng {
  width: 52px !important;
  height: auto;
  cursor: pointer;
}

.delPngBox {
  margin-top: 0.35rem;
  border-bottom: 1px solid #F1F3F4;
}

.adPng {
  width: 52px !important;
  height: 52px;
  cursor: pointer;
}

.secondary-confirm-content {
  margin-left: 0.05rem;
  display: flex;
  align-items: center;

  .img-text {
    padding-left: 12px;
    font-size: 24px;
    color: #444;
  }

  .img-icon {
    width: 28px !important;
    height: 30px;
  }
}

.notes {
  margin-left: 0.32rem;
  font-size: 24px;
  color: #888888;
  margin-top: 15px;
  line-height: 34px;
  margin-right: 30px;
}

/deep/ .van-button__text {
  width: 100%;
}

.account-details-box {
  //background: rgb(250, 250, 250);
  margin-top: 20px;
  //border: 5px solid red;
  border-left: 0;
  border-right: 0;
}

/deep/ .van-cell {
  // border-bottom:1px solid #F5F6F7;
}
</style>
